import jQuery from "jquery";
/*! jQuery UI - v1.10.3 - 2013-12-19
 * http://jqueryui.com
 * Includes: jquery.ui.core.js, jquery.ui.widget.js, jquery.ui.mouse.js, jquery.ui.draggable.js, jquery.ui.droppable.js, jquery.ui.sortable.js, jquery.ui.effect.js, jquery.ui.effect-highlight.js
 * Copyright 2013 jQuery Foundation and other contributors; Licensed MIT */

(function ($, undefined) {
  var uuid = 0;
  var runiqueId = /^ui-id-\d+$/;

  // $.ui might exist from components with no dependencies, e.g., $.ui.position
  $.ui = $.ui || {};

  $.extend($.ui, {
    version: "1.10.3",

    keyCode: {
      BACKSPACE: 8,
      COMMA: 188,
      DELETE: 46,
      DOWN: 40,
      END: 35,
      ENTER: 13,
      ESCAPE: 27,
      HOME: 36,
      LEFT: 37,
      NUMPAD_ADD: 107,
      NUMPAD_DECIMAL: 110,
      NUMPAD_DIVIDE: 111,
      NUMPAD_ENTER: 108,
      NUMPAD_MULTIPLY: 106,
      NUMPAD_SUBTRACT: 109,
      PAGE_DOWN: 34,
      PAGE_UP: 33,
      PERIOD: 190,
      RIGHT: 39,
      SPACE: 32,
      TAB: 9,
      UP: 38,
    },
  });

  // plugins
  $.fn.extend({
    focus: (function (orig) {
      return function (delay, fn) {
        return typeof delay === "number"
          ? this.each(function () {
              var elem = this;
              setTimeout(function () {
                $(elem).focus();
                if (fn) {
                  fn.call(elem);
                }
              }, delay);
            })
          : orig.apply(this, arguments);
      };
    })($.fn.focus),

    scrollParent: function () {
      var scrollParent;
      if (
        ($.ui.ie && /(static|relative)/.test(this.css("position"))) ||
        /absolute/.test(this.css("position"))
      ) {
        scrollParent = this.parents()
          .filter(function () {
            return (
              /(relative|absolute|fixed)/.test($.css(this, "position")) &&
              /(auto|scroll)/.test(
                $.css(this, "overflow") +
                  $.css(this, "overflow-y") +
                  $.css(this, "overflow-x")
              )
            );
          })
          .eq(0);
      } else {
        scrollParent = this.parents()
          .filter(function () {
            return /(auto|scroll)/.test(
              $.css(this, "overflow") +
                $.css(this, "overflow-y") +
                $.css(this, "overflow-x")
            );
          })
          .eq(0);
      }

      return /fixed/.test(this.css("position")) || !scrollParent.length
        ? $(document)
        : scrollParent;
    },

    zIndex: function (zIndex) {
      if (zIndex !== undefined) {
        return this.css("zIndex", zIndex);
      }

      if (this.length) {
        var elem = $(this[0]);
        var position;
        var value;
        while (elem.length && elem[0] !== document) {
          // Ignore z-index if position is set to a value where z-index is ignored by the browser
          // This makes behavior of this function consistent across browsers
          // WebKit always returns auto if the element is positioned
          position = elem.css("position");
          if (
            position === "absolute" ||
            position === "relative" ||
            position === "fixed"
          ) {
            // IE returns 0 when zIndex is not specified
            // other browsers return a string
            // we ignore the case of nested elements with an explicit value of 0
            // <div style="z-index: -10;"><div style="z-index: 0;"></div></div>
            value = parseInt(elem.css("zIndex"), 10);
            if (!isNaN(value) && value !== 0) {
              return value;
            }
          }
          elem = elem.parent();
        }
      }

      return 0;
    },

    uniqueId: function () {
      return this.each(function () {
        if (!this.id) {
          this.id = "ui-id-" + ++uuid;
        }
      });
    },

    removeUniqueId: function () {
      return this.each(function () {
        if (runiqueId.test(this.id)) {
          $(this).removeAttr("id");
        }
      });
    },
  });

  // selectors
  function focusable(element, isTabIndexNotNaN) {
    var map;
    var mapName;
    var img;
    var nodeName = element.nodeName.toLowerCase();
    if (nodeName === "area") {
      map = element.parentNode;
      mapName = map.name;
      if (!element.href || !mapName || map.nodeName.toLowerCase() !== "map") {
        return false;
      }
      img = $("img[usemap=#" + mapName + "]")[0];
      return !!img && visible(img);
    }
    return (
      (/input|select|textarea|button|object/.test(nodeName)
        ? !element.disabled
        : nodeName === "a"
        ? element.href || isTabIndexNotNaN
        : isTabIndexNotNaN) &&
      // the element and all of its ancestors must be visible
      visible(element)
    );
  }

  function visible(element) {
    return (
      $.expr.filters.visible(element) &&
      !$(element)
        .parents()
        .addBack()
        .filter(function () {
          return $.css(this, "visibility") === "hidden";
        }).length
    );
  }

  $.extend($.expr[":"], {
    data: $.expr.createPseudo
      ? $.expr.createPseudo(function (dataName) {
          return function (elem) {
            return !!$.data(elem, dataName);
          };
        })
      : // support: jQuery <1.8
        function (elem, i, match) {
          return !!$.data(elem, match[3]);
        },

    focusable: function (element) {
      return focusable(element, !isNaN($.attr(element, "tabindex")));
    },

    tabbable: function (element) {
      var tabIndex = $.attr(element, "tabindex");
      var isTabIndexNaN = isNaN(tabIndex);
      return (
        (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN)
      );
    },
  });

  // support: jQuery <1.8
  if (!$("<a>").outerWidth(1).jquery) {
    $.each(["Width", "Height"], function (i, name) {
      var side = name === "Width" ? ["Left", "Right"] : ["Top", "Bottom"];
      var type = name.toLowerCase();
      var orig = {
        innerWidth: $.fn.innerWidth,
        innerHeight: $.fn.innerHeight,
        outerWidth: $.fn.outerWidth,
        outerHeight: $.fn.outerHeight,
      };

      function reduce(elem, size, border, margin) {
        $.each(side, function () {
          size -= parseFloat($.css(elem, "padding" + this)) || 0;
          if (border) {
            size -= parseFloat($.css(elem, "border" + this + "Width")) || 0;
          }
          if (margin) {
            size -= parseFloat($.css(elem, "margin" + this)) || 0;
          }
        });
        return size;
      }

      $.fn["inner" + name] = function (size) {
        if (size === undefined) {
          return orig["inner" + name].call(this);
        }

        return this.each(function () {
          $(this).css(type, reduce(this, size) + "px");
        });
      };

      $.fn["outer" + name] = function (size, margin) {
        if (typeof size !== "number") {
          return orig["outer" + name].call(this, size);
        }

        return this.each(function () {
          $(this).css(type, reduce(this, size, true, margin) + "px");
        });
      };
    });
  }

  // support: jQuery <1.8
  if (!$.fn.addBack) {
    $.fn.addBack = function (selector) {
      return this.add(
        selector == null ? this.prevObject : this.prevObject.filter(selector)
      );
    };
  }

  // support: jQuery 1.6.1, 1.6.2 (http://bugs.jquery.com/ticket/9413)
  if ($("<a>").data("a-b", "a").removeData("a-b").data("a-b")) {
    $.fn.removeData = (function (removeData) {
      return function (key) {
        if (arguments.length) {
          return removeData.call(this, $.camelCase(key));
        } else {
          return removeData.call(this);
        }
      };
    })($.fn.removeData);
  }

  // deprecated
  $.ui.ie = !!/msie [\w.]+/.exec(navigator.userAgent.toLowerCase());

  $.support.selectstart = "onselectstart" in document.createElement("div");
  $.fn.extend({
    disableSelection: function () {
      return this.bind(
        ($.support.selectstart ? "selectstart" : "mousedown") +
          ".ui-disableSelection",
        function (event) {
          event.preventDefault();
        }
      );
    },

    enableSelection: function () {
      return this.unbind(".ui-disableSelection");
    },
  });

  $.extend($.ui, {
    // $.ui.plugin is deprecated. Use $.widget() extensions instead.
    plugin: {
      add: function (module, option, set) {
        var i;
        var proto = $.ui[module].prototype;
        for (i in set) {
          proto.plugins[i] = proto.plugins[i] || [];
          proto.plugins[i].push([option, set[i]]);
        }
      },
      call: function (instance, name, args) {
        var i;
        var set = instance.plugins[name];
        if (
          !set ||
          !instance.element[0].parentNode ||
          instance.element[0].parentNode.nodeType === 11
        ) {
          return;
        }

        for (i = 0; i < set.length; i++) {
          if (instance.options[set[i][0]]) {
            set[i][1].apply(instance.element, args);
          }
        }
      },
    },

    // only used by resizable
    hasScroll: function (el, a) {
      // If overflow is hidden, the element might have extra content, but the user wants to hide it
      if ($(el).css("overflow") === "hidden") {
        return false;
      }

      var scroll = a && a === "left" ? "scrollLeft" : "scrollTop";
      var has = false;

      if (el[scroll] > 0) {
        return true;
      }

      // TODO: determine which cases actually cause this to happen
      // if the element doesn't have the scroll set, see if it's possible to
      // set the scroll
      el[scroll] = 1;
      has = el[scroll] > 0;
      el[scroll] = 0;
      return has;
    },
  });
})(jQuery);
(function ($, undefined) {
  var uuid = 0;
  var slice = Array.prototype.slice;
  var _cleanData = $.cleanData;
  $.cleanData = function (elems) {
    for (var i = 0, elem; (elem = elems[i]) != null; i++) {
      try {
        $(elem).triggerHandler("remove");
        // http://bugs.jquery.com/ticket/8235
      } catch (e) {}
    }
    _cleanData(elems);
  };

  $.widget = function (name, base, prototype) {
    var fullName;
    var existingConstructor;
    var constructor;
    var basePrototype;
    // proxiedPrototype allows the provided prototype to remain unmodified
    // so that it can be used as a mixin for multiple widgets (#8876)
    var proxiedPrototype = {};
    var namespace = name.split(".")[0];

    name = name.split(".")[1];
    fullName = namespace + "-" + name;

    if (!prototype) {
      prototype = base;
      base = $.Widget;
    }

    // create selector for plugin
    $.expr[":"][fullName.toLowerCase()] = function (elem) {
      return !!$.data(elem, fullName);
    };

    $[namespace] = $[namespace] || {};
    existingConstructor = $[namespace][name];
    constructor = $[namespace][name] = function (options, element) {
      // allow instantiation without "new" keyword
      if (!this._createWidget) {
        return new constructor(options, element);
      }

      // allow instantiation without initializing for simple inheritance
      // must use "new" keyword (the code above always passes args)
      if (arguments.length) {
        this._createWidget(options, element);
      }
    };
    // extend with the existing constructor to carry over any static properties
    $.extend(constructor, existingConstructor, {
      version: prototype.version,
      // copy the object used to create the prototype in case we need to
      // redefine the widget later
      _proto: $.extend({}, prototype),
      // track widgets that inherit from this widget in case this widget is
      // redefined after a widget inherits from it
      _childConstructors: [],
    });

    basePrototype = new base();
    // we need to make the options hash a property directly on the new instance
    // otherwise we'll modify the options hash on the prototype that we're
    // inheriting from
    basePrototype.options = $.widget.extend({}, basePrototype.options);
    $.each(prototype, function (prop, value) {
      if (!$.isFunction(value)) {
        proxiedPrototype[prop] = value;
        return;
      }
      proxiedPrototype[prop] = (function () {
        var _super = function () {
          return base.prototype[prop].apply(this, arguments);
        };
        var _superApply = function (args) {
          return base.prototype[prop].apply(this, args);
        };
        return function () {
          var __super = this._super;
          var __superApply = this._superApply;
          var returnValue;

          this._super = _super;
          this._superApply = _superApply;

          returnValue = value.apply(this, arguments);

          this._super = __super;
          this._superApply = __superApply;

          return returnValue;
        };
      })();
    });
    constructor.prototype = $.widget.extend(
      basePrototype,
      {
        // TODO: remove support for widgetEventPrefix
        // always use the name + a colon as the prefix, e.g., draggable:start
        // don't prefix for widgets that aren't DOM-based
        widgetEventPrefix: existingConstructor
          ? basePrototype.widgetEventPrefix
          : name,
      },
      proxiedPrototype,
      {
        constructor: constructor,
        namespace: namespace,
        widgetName: name,
        widgetFullName: fullName,
      }
    );

    // If this widget is being redefined then we need to find all widgets that
    // are inheriting from it and redefine all of them so that they inherit from
    // the new version of this widget. We're essentially trying to replace one
    // level in the prototype chain.
    if (existingConstructor) {
      $.each(existingConstructor._childConstructors, function (i, child) {
        var childPrototype = child.prototype;

        // redefine the child widget using the same prototype that was
        // originally used, but inherit from the new version of the base
        $.widget(
          childPrototype.namespace + "." + childPrototype.widgetName,
          constructor,
          child._proto
        );
      });
      // remove the list of existing child constructors from the old constructor
      // so the old child constructors can be garbage collected
      delete existingConstructor._childConstructors;
    } else {
      base._childConstructors.push(constructor);
    }

    $.widget.bridge(name, constructor);
  };

  $.widget.extend = function (target) {
    var input = slice.call(arguments, 1);
    var inputIndex = 0;
    var inputLength = input.length;
    var key;
    var value;
    for (; inputIndex < inputLength; inputIndex++) {
      for (key in input[inputIndex]) {
        value = input[inputIndex][key];
        if (input[inputIndex].hasOwnProperty(key) && value !== undefined) {
          // Clone objects
          if ($.isPlainObject(value)) {
            target[key] = $.isPlainObject(target[key])
              ? $.widget.extend({}, target[key], value)
              : // Don't extend strings, arrays, etc. with objects
                $.widget.extend({}, value);
            // Copy everything else by reference
          } else {
            target[key] = value;
          }
        }
      }
    }
    return target;
  };

  $.widget.bridge = function (name, object) {
    var fullName = object.prototype.widgetFullName || name;
    $.fn[name] = function (options) {
      var isMethodCall = typeof options === "string";
      var args = slice.call(arguments, 1);
      var returnValue = this;

      // allow multiple hashes to be passed on init
      options =
        !isMethodCall && args.length
          ? $.widget.extend.apply(null, [options].concat(args))
          : options;

      if (isMethodCall) {
        this.each(function () {
          var methodValue;
          var instance = $.data(this, fullName);
          if (!instance) {
            return $.error(
              "cannot call methods on " +
                name +
                " prior to initialization; " +
                "attempted to call method '" +
                options +
                "'"
            );
          }
          if (!$.isFunction(instance[options]) || options.charAt(0) === "_") {
            return $.error(
              "no such method '" +
                options +
                "' for " +
                name +
                " widget instance"
            );
          }
          methodValue = instance[options].apply(instance, args);
          if (methodValue !== instance && methodValue !== undefined) {
            returnValue =
              methodValue && methodValue.jquery
                ? returnValue.pushStack(methodValue.get())
                : methodValue;
            return false;
          }
        });
      } else {
        this.each(function () {
          var instance = $.data(this, fullName);
          if (instance) {
            instance.option(options || {})._init();
          } else {
            $.data(this, fullName, new object(options, this));
          }
        });
      }

      return returnValue;
    };
  };

  $.Widget = function (/* options, element */) {};
  $.Widget._childConstructors = [];

  $.Widget.prototype = {
    widgetName: "widget",
    widgetEventPrefix: "",
    defaultElement: "<div>",
    options: {
      disabled: false,

      // callbacks
      create: null,
    },
    _createWidget: function (options, element) {
      element = $(element || this.defaultElement || this)[0];
      this.element = $(element);
      this.uuid = uuid++;
      this.eventNamespace = "." + this.widgetName + this.uuid;
      this.options = $.widget.extend(
        {},
        this.options,
        this._getCreateOptions(),
        options
      );

      this.bindings = $();
      this.hoverable = $();
      this.focusable = $();

      if (element !== this) {
        $.data(element, this.widgetFullName, this);
        this._on(true, this.element, {
          remove: function (event) {
            if (event.target === element) {
              this.destroy();
            }
          },
        });
        this.document = $(
          element.style
            ? // element within the document
              element.ownerDocument
            : // element is window or document
              element.document || element
        );
        this.window = $(
          this.document[0].defaultView || this.document[0].parentWindow
        );
      }

      this._create();
      this._trigger("create", null, this._getCreateEventData());
      this._init();
    },
    _getCreateOptions: $.noop,
    _getCreateEventData: $.noop,
    _create: $.noop,
    _init: $.noop,

    destroy: function () {
      this._destroy();
      // we can probably remove the unbind calls in 2.0
      // all event bindings should go through this._on()
      this.element
        .unbind(this.eventNamespace)
        // 1.9 BC for #7810
        // TODO remove dual storage
        .removeData(this.widgetName)
        .removeData(this.widgetFullName)
        // support: jquery <1.6.3
        // http://bugs.jquery.com/ticket/9413
        .removeData($.camelCase(this.widgetFullName));
      this.widget()
        .unbind(this.eventNamespace)
        .removeAttr("aria-disabled")
        .removeClass(this.widgetFullName + "-disabled " + "ui-state-disabled");

      // clean up events and states
      this.bindings.unbind(this.eventNamespace);
      this.hoverable.removeClass("ui-state-hover");
      this.focusable.removeClass("ui-state-focus");
    },
    _destroy: $.noop,

    widget: function () {
      return this.element;
    },

    option: function (key, value) {
      var options = key;
      var parts;
      var curOption;
      var i;

      if (arguments.length === 0) {
        // don't return a reference to the internal hash
        return $.widget.extend({}, this.options);
      }

      if (typeof key === "string") {
        // handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
        options = {};
        parts = key.split(".");
        key = parts.shift();
        if (parts.length) {
          curOption = options[key] = $.widget.extend({}, this.options[key]);
          for (i = 0; i < parts.length - 1; i++) {
            curOption[parts[i]] = curOption[parts[i]] || {};
            curOption = curOption[parts[i]];
          }
          key = parts.pop();
          if (value === undefined) {
            return curOption[key] === undefined ? null : curOption[key];
          }
          curOption[key] = value;
        } else {
          if (value === undefined) {
            return this.options[key] === undefined ? null : this.options[key];
          }
          options[key] = value;
        }
      }

      this._setOptions(options);

      return this;
    },
    _setOptions: function (options) {
      var key;

      for (key in options) {
        this._setOption(key, options[key]);
      }

      return this;
    },
    _setOption: function (key, value) {
      this.options[key] = value;

      if (key === "disabled") {
        this.widget()
          .toggleClass(
            this.widgetFullName + "-disabled ui-state-disabled",
            !!value
          )
          .attr("aria-disabled", value);
        this.hoverable.removeClass("ui-state-hover");
        this.focusable.removeClass("ui-state-focus");
      }

      return this;
    },

    enable: function () {
      return this._setOption("disabled", false);
    },
    disable: function () {
      return this._setOption("disabled", true);
    },

    _on: function (suppressDisabledCheck, element, handlers) {
      var delegateElement;
      var instance = this;

      // no suppressDisabledCheck flag, shuffle arguments
      if (typeof suppressDisabledCheck !== "boolean") {
        handlers = element;
        element = suppressDisabledCheck;
        suppressDisabledCheck = false;
      }

      // no element argument, shuffle and use this.element
      if (!handlers) {
        handlers = element;
        element = this.element;
        delegateElement = this.widget();
      } else {
        // accept selectors, DOM elements
        element = delegateElement = $(element);
        this.bindings = this.bindings.add(element);
      }

      $.each(handlers, function (event, handler) {
        function handlerProxy() {
          // allow widgets to customize the disabled handling
          // - disabled as an array instead of boolean
          // - disabled class as method for disabling individual parts
          if (
            !suppressDisabledCheck &&
            (instance.options.disabled === true ||
              $(this).hasClass("ui-state-disabled"))
          ) {
            return;
          }
          return (typeof handler === "string"
            ? instance[handler]
            : handler
          ).apply(instance, arguments);
        }

        // copy the guid so direct unbinding works
        if (typeof handler !== "string") {
          handlerProxy.guid = handler.guid =
            handler.guid || handlerProxy.guid || $.guid++;
        }

        var match = event.match(/^(\w+)\s*(.*)$/);
        var eventName = match[1] + instance.eventNamespace;
        var selector = match[2];
        if (selector) {
          delegateElement.delegate(selector, eventName, handlerProxy);
        } else {
          element.bind(eventName, handlerProxy);
        }
      });
    },

    _off: function (element, eventName) {
      eventName =
        (eventName || "").split(" ").join(this.eventNamespace + " ") +
        this.eventNamespace;
      element.unbind(eventName).undelegate(eventName);
    },

    _delay: function (handler, delay) {
      function handlerProxy() {
        return (typeof handler === "string"
          ? instance[handler]
          : handler
        ).apply(instance, arguments);
      }
      var instance = this;
      return setTimeout(handlerProxy, delay || 0);
    },

    _hoverable: function (element) {
      this.hoverable = this.hoverable.add(element);
      this._on(element, {
        mouseenter: function (event) {
          $(event.currentTarget).addClass("ui-state-hover");
        },
        mouseleave: function (event) {
          $(event.currentTarget).removeClass("ui-state-hover");
        },
      });
    },

    _focusable: function (element) {
      this.focusable = this.focusable.add(element);
      this._on(element, {
        focusin: function (event) {
          $(event.currentTarget).addClass("ui-state-focus");
        },
        focusout: function (event) {
          $(event.currentTarget).removeClass("ui-state-focus");
        },
      });
    },

    _trigger: function (type, event, data) {
      var prop;
      var orig;
      var callback = this.options[type];

      data = data || {};
      event = $.Event(event);
      event.type = (type === this.widgetEventPrefix
        ? type
        : this.widgetEventPrefix + type
      ).toLowerCase();
      // the original event may come from any element
      // so we need to reset the target on the new event
      event.target = this.element[0];

      // copy original event properties over to the new event
      orig = event.originalEvent;
      if (orig) {
        for (prop in orig) {
          if (!(prop in event)) {
            event[prop] = orig[prop];
          }
        }
      }

      this.element.trigger(event, data);
      return !(
        ($.isFunction(callback) &&
          callback.apply(this.element[0], [event].concat(data)) === false) ||
        event.isDefaultPrevented()
      );
    },
  };

  $.each({ show: "fadeIn", hide: "fadeOut" }, function (method, defaultEffect) {
    $.Widget.prototype["_" + method] = function (element, options, callback) {
      if (typeof options === "string") {
        options = { effect: options };
      }
      var hasOptions;
      var effectName = !options
        ? method
        : options === true || typeof options === "number"
        ? defaultEffect
        : options.effect || defaultEffect;
      options = options || {};
      if (typeof options === "number") {
        options = { duration: options };
      }
      hasOptions = !$.isEmptyObject(options);
      options.complete = callback;
      if (options.delay) {
        element.delay(options.delay);
      }
      if (hasOptions && $.effects && $.effects.effect[effectName]) {
        element[method](options);
      } else if (effectName !== method && element[effectName]) {
        element[effectName](options.duration, options.easing, callback);
      } else {
        element.queue(function (next) {
          $(this)[method]();
          if (callback) {
            callback.call(element[0]);
          }
          next();
        });
      }
    };
  });
})(jQuery);
(function ($, undefined) {
  var mouseHandled = false;
  $(document).mouseup(function () {
    mouseHandled = false;
  });

  $.widget("ui.mouse", {
    version: "1.10.3",
    options: {
      cancel: "input,textarea,button,select,option",
      distance: 1,
      delay: 0,
    },
    _mouseInit: function () {
      var that = this;

      this.element
        .bind("mousedown." + this.widgetName, function (event) {
          return that._mouseDown(event);
        })
        .bind("click." + this.widgetName, function (event) {
          if (
            $.data(event.target, that.widgetName + ".preventClickEvent") ===
            true
          ) {
            $.removeData(event.target, that.widgetName + ".preventClickEvent");
            event.stopImmediatePropagation();
            return false;
          }
        });

      this.started = false;
    },

    // TODO: make sure destroying one instance of mouse doesn't mess with
    // other instances of mouse
    _mouseDestroy: function () {
      this.element.unbind("." + this.widgetName);
      if (this._mouseMoveDelegate) {
        $(document)
          .unbind("mousemove." + this.widgetName, this._mouseMoveDelegate)
          .unbind("mouseup." + this.widgetName, this._mouseUpDelegate);
      }
    },

    _mouseDown: function (event) {
      // don't let more than one widget handle mouseStart
      if (mouseHandled) {
        return;
      }

      // we may have missed mouseup (out of window)
      this._mouseStarted && this._mouseUp(event);

      this._mouseDownEvent = event;

      var that = this;
      var btnIsLeft = event.which === 1;
      // event.target.nodeName works around a bug in IE 8 with
      // disabled inputs (#7620)
      var elIsCancel =
        typeof this.options.cancel === "string" && event.target.nodeName
          ? $(event.target).closest(this.options.cancel).length
          : false;
      if (!btnIsLeft || elIsCancel || !this._mouseCapture(event)) {
        return true;
      }

      this.mouseDelayMet = !this.options.delay;
      if (!this.mouseDelayMet) {
        this._mouseDelayTimer = setTimeout(function () {
          that.mouseDelayMet = true;
        }, this.options.delay);
      }

      if (this._mouseDistanceMet(event) && this._mouseDelayMet(event)) {
        this._mouseStarted = this._mouseStart(event) !== false;
        if (!this._mouseStarted) {
          event.preventDefault();
          return true;
        }
      }

      // Click event may never have fired (Gecko & Opera)
      if (
        $.data(event.target, this.widgetName + ".preventClickEvent") === true
      ) {
        $.removeData(event.target, this.widgetName + ".preventClickEvent");
      }

      // these delegates are required to keep context
      this._mouseMoveDelegate = function (event) {
        return that._mouseMove(event);
      };
      this._mouseUpDelegate = function (event) {
        return that._mouseUp(event);
      };
      $(document)
        .bind("mousemove." + this.widgetName, this._mouseMoveDelegate)
        .bind("mouseup." + this.widgetName, this._mouseUpDelegate);

      event.preventDefault();

      mouseHandled = true;
      return true;
    },

    _mouseMove: function (event) {
      // IE mouseup check - mouseup happened when mouse was out of window
      if (
        $.ui.ie &&
        (!document.documentMode || document.documentMode < 9) &&
        !event.button
      ) {
        return this._mouseUp(event);
      }

      if (this._mouseStarted) {
        this._mouseDrag(event);
        return event.preventDefault();
      }

      if (this._mouseDistanceMet(event) && this._mouseDelayMet(event)) {
        this._mouseStarted =
          this._mouseStart(this._mouseDownEvent, event) !== false;
        this._mouseStarted ? this._mouseDrag(event) : this._mouseUp(event);
      }

      return !this._mouseStarted;
    },

    _mouseUp: function (event) {
      $(document)
        .unbind("mousemove." + this.widgetName, this._mouseMoveDelegate)
        .unbind("mouseup." + this.widgetName, this._mouseUpDelegate);

      if (this._mouseStarted) {
        this._mouseStarted = false;

        if (event.target === this._mouseDownEvent.target) {
          $.data(event.target, this.widgetName + ".preventClickEvent", true);
        }

        this._mouseStop(event);
      }

      return false;
    },

    _mouseDistanceMet: function (event) {
      return (
        Math.max(
          Math.abs(this._mouseDownEvent.pageX - event.pageX),
          Math.abs(this._mouseDownEvent.pageY - event.pageY)
        ) >= this.options.distance
      );
    },

    _mouseDelayMet: function (/* event */) {
      return this.mouseDelayMet;
    },

    // These are placeholder methods, to be overriden by extending plugin
    _mouseStart: function (/* event */) {},
    _mouseDrag: function (/* event */) {},
    _mouseStop: function (/* event */) {},
    _mouseCapture: function (/* event */) {
      return true;
    },
  });
})(jQuery);
(function ($, undefined) {
  $.widget("ui.draggable", $.ui.mouse, {
    version: "1.10.3",
    widgetEventPrefix: "drag",
    options: {
      addClasses: true,
      appendTo: "parent",
      axis: false,
      connectToSortable: false,
      containment: false,
      cursor: "auto",
      cursorAt: false,
      grid: false,
      handle: false,
      helper: "original",
      iframeFix: false,
      opacity: false,
      refreshPositions: false,
      revert: false,
      revertDuration: 500,
      scope: "default",
      scroll: true,
      scrollSensitivity: 20,
      scrollSpeed: 20,
      snap: false,
      snapMode: "both",
      snapTolerance: 20,
      stack: false,
      zIndex: false,

      // callbacks
      drag: null,
      start: null,
      stop: null,
    },
    _create: function () {
      if (
        this.options.helper === "original" &&
        !/^(?:r|a|f)/.test(this.element.css("position"))
      ) {
        this.element[0].style.position = "relative";
      }
      if (this.options.addClasses) {
        this.element.addClass("ui-draggable");
      }
      if (this.options.disabled) {
        this.element.addClass("ui-draggable-disabled");
      }

      this._mouseInit();
    },

    _destroy: function () {
      this.element.removeClass(
        "ui-draggable ui-draggable-dragging ui-draggable-disabled"
      );
      this._mouseDestroy();
    },

    _mouseCapture: function (event) {
      var o = this.options;

      // among others, prevent a drag on a resizable-handle
      if (
        this.helper ||
        o.disabled ||
        $(event.target).closest(".ui-resizable-handle").length > 0
      ) {
        return false;
      }

      // Quit if we're not on a valid handle
      this.handle = this._getHandle(event);
      if (!this.handle) {
        return false;
      }

      $(o.iframeFix === true ? "iframe" : o.iframeFix).each(function () {
        $(
          "<div class='ui-draggable-iframeFix' style='background: #fff;'></div>"
        )
          .css({
            width: this.offsetWidth + "px",
            height: this.offsetHeight + "px",
            position: "absolute",
            opacity: "0.001",
            zIndex: 1000,
          })
          .css($(this).offset())
          .appendTo("body");
      });

      return true;
    },

    _mouseStart: function (event) {
      var o = this.options;

      // Create and append the visible helper
      this.helper = this._createHelper(event);

      this.helper.addClass("ui-draggable-dragging");

      // Cache the helper size
      this._cacheHelperProportions();

      // If ddmanager is used for droppables, set the global draggable
      if ($.ui.ddmanager) {
        $.ui.ddmanager.current = this;
      }

      /*
       * - Position generation -
       * This block generates everything position related - it's the core of draggables.
       */

      // Cache the margins of the original element
      this._cacheMargins();

      // Store the helper's css position
      this.cssPosition = this.helper.css("position");
      this.scrollParent = this.helper.scrollParent();
      this.offsetParent = this.helper.offsetParent();
      this.offsetParentCssPosition = this.offsetParent.css("position");

      // The element's absolute position on the page minus margins
      this.offset = this.positionAbs = this.element.offset();
      this.offset = {
        top: this.offset.top - this.margins.top,
        left: this.offset.left - this.margins.left,
      };

      // Reset scroll cache
      this.offset.scroll = false;

      $.extend(this.offset, {
        click: {
          // Where the click happened, relative to the element
          left: event.pageX - this.offset.left,
          top: event.pageY - this.offset.top,
        },
        parent: this._getParentOffset(),
        relative: this._getRelativeOffset(), // This is a relative to absolute position minus the actual position calculation - only used for relative positioned helper
      });

      // Generate the original position
      this.originalPosition = this.position = this._generatePosition(event);
      this.originalPageX = event.pageX;
      this.originalPageY = event.pageY;

      // Adjust the mouse offset relative to the helper if "cursorAt" is supplied
      o.cursorAt && this._adjustOffsetFromHelper(o.cursorAt);

      // Set a containment if given in the options
      this._setContainment();

      // Trigger event + callbacks
      if (this._trigger("start", event) === false) {
        this._clear();
        return false;
      }

      // Recache the helper size
      this._cacheHelperProportions();

      // Prepare the droppable offsets
      if ($.ui.ddmanager && !o.dropBehaviour) {
        $.ui.ddmanager.prepareOffsets(this, event);
      }

      this._mouseDrag(event, true); // Execute the drag once - this causes the helper not to be visible before getting its correct position

      // If the ddmanager is used for droppables, inform the manager that dragging has started (see #5003)
      if ($.ui.ddmanager) {
        $.ui.ddmanager.dragStart(this, event);
      }

      return true;
    },

    _mouseDrag: function (event, noPropagation) {
      // reset any necessary cached properties (see #5009)
      if (this.offsetParentCssPosition === "fixed") {
        this.offset.parent = this._getParentOffset();
      }

      // Compute the helpers position
      this.position = this._generatePosition(event);
      this.positionAbs = this._convertPositionTo("absolute");

      // Call plugins and callbacks and use the resulting position if something is returned
      if (!noPropagation) {
        var ui = this._uiHash();
        if (this._trigger("drag", event, ui) === false) {
          this._mouseUp({});
          return false;
        }
        this.position = ui.position;
      }

      if (!this.options.axis || this.options.axis !== "y") {
        this.helper[0].style.left = this.position.left + "px";
      }
      if (!this.options.axis || this.options.axis !== "x") {
        this.helper[0].style.top = this.position.top + "px";
      }
      if ($.ui.ddmanager) {
        $.ui.ddmanager.drag(this, event);
      }

      return false;
    },

    _mouseStop: function (event) {
      // If we are using droppables, inform the manager about the drop
      var that = this;
      var dropped = false;
      if ($.ui.ddmanager && !this.options.dropBehaviour) {
        dropped = $.ui.ddmanager.drop(this, event);
      }

      // if a drop comes from outside (a sortable)
      if (this.dropped) {
        dropped = this.dropped;
        this.dropped = false;
      }

      // if the original element is no longer in the DOM don't bother to continue (see #8269)
      if (
        this.options.helper === "original" &&
        !$.contains(this.element[0].ownerDocument, this.element[0])
      ) {
        return false;
      }

      if (
        (this.options.revert === "invalid" && !dropped) ||
        (this.options.revert === "valid" && dropped) ||
        this.options.revert === true ||
        ($.isFunction(this.options.revert) &&
          this.options.revert.call(this.element, dropped))
      ) {
        $(this.helper).animate(
          this.originalPosition,
          parseInt(this.options.revertDuration, 10),
          function () {
            if (that._trigger("stop", event) !== false) {
              that._clear();
            }
          }
        );
      } else {
        if (this._trigger("stop", event) !== false) {
          this._clear();
        }
      }

      return false;
    },

    _mouseUp: function (event) {
      // Remove frame helpers
      $("div.ui-draggable-iframeFix").each(function () {
        this.parentNode.removeChild(this);
      });

      // If the ddmanager is used for droppables, inform the manager that dragging has stopped (see #5003)
      if ($.ui.ddmanager) {
        $.ui.ddmanager.dragStop(this, event);
      }

      return $.ui.mouse.prototype._mouseUp.call(this, event);
    },

    cancel: function () {
      if (this.helper.is(".ui-draggable-dragging")) {
        this._mouseUp({});
      } else {
        this._clear();
      }

      return this;
    },

    _getHandle: function (event) {
      return this.options.handle
        ? !!$(event.target).closest(this.element.find(this.options.handle))
            .length
        : true;
    },

    _createHelper: function (event) {
      var o = this.options;
      var helper = $.isFunction(o.helper)
        ? $(o.helper.apply(this.element[0], [event]))
        : o.helper === "clone"
        ? this.element.clone().removeAttr("id")
        : this.element;

      if (!helper.parents("body").length) {
        helper.appendTo(
          o.appendTo === "parent" ? this.element[0].parentNode : o.appendTo
        );
      }

      if (
        helper[0] !== this.element[0] &&
        !/(fixed|absolute)/.test(helper.css("position"))
      ) {
        helper.css("position", "absolute");
      }

      return helper;
    },

    _adjustOffsetFromHelper: function (obj) {
      if (typeof obj === "string") {
        obj = obj.split(" ");
      }
      if ($.isArray(obj)) {
        obj = { left: +obj[0], top: +obj[1] || 0 };
      }
      if ("left" in obj) {
        this.offset.click.left = obj.left + this.margins.left;
      }
      if ("right" in obj) {
        this.offset.click.left =
          this.helperProportions.width - obj.right + this.margins.left;
      }
      if ("top" in obj) {
        this.offset.click.top = obj.top + this.margins.top;
      }
      if ("bottom" in obj) {
        this.offset.click.top =
          this.helperProportions.height - obj.bottom + this.margins.top;
      }
    },

    _getParentOffset: function () {
      // Get the offsetParent and cache its position
      var po = this.offsetParent.offset();

      // This is a special case where we need to modify a offset calculated on start, since the following happened:
      // 1. The position of the helper is absolute, so it's position is calculated based on the next positioned parent
      // 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't the document, which means that
      //    the scroll is included in the initial calculation of the offset of the parent, and never recalculated upon drag
      if (
        this.cssPosition === "absolute" &&
        this.scrollParent[0] !== document &&
        $.contains(this.scrollParent[0], this.offsetParent[0])
      ) {
        po.left += this.scrollParent.scrollLeft();
        po.top += this.scrollParent.scrollTop();
      }

      // This needs to be actually done for all browsers, since pageX/pageY includes this information
      // Ugly IE fix
      if (
        this.offsetParent[0] === document.body ||
        (this.offsetParent[0].tagName &&
          this.offsetParent[0].tagName.toLowerCase() === "html" &&
          $.ui.ie)
      ) {
        po = { top: 0, left: 0 };
      }

      return {
        top:
          po.top + (parseInt(this.offsetParent.css("borderTopWidth"), 10) || 0),
        left:
          po.left +
          (parseInt(this.offsetParent.css("borderLeftWidth"), 10) || 0),
      };
    },

    _getRelativeOffset: function () {
      if (this.cssPosition === "relative") {
        var p = this.element.position();
        return {
          top:
            p.top -
            (parseInt(this.helper.css("top"), 10) || 0) +
            this.scrollParent.scrollTop(),
          left:
            p.left -
            (parseInt(this.helper.css("left"), 10) || 0) +
            this.scrollParent.scrollLeft(),
        };
      } else {
        return { top: 0, left: 0 };
      }
    },

    _cacheMargins: function () {
      this.margins = {
        left: parseInt(this.element.css("marginLeft"), 10) || 0,
        top: parseInt(this.element.css("marginTop"), 10) || 0,
        right: parseInt(this.element.css("marginRight"), 10) || 0,
        bottom: parseInt(this.element.css("marginBottom"), 10) || 0,
      };
    },

    _cacheHelperProportions: function () {
      this.helperProportions = {
        width: this.helper.outerWidth(),
        height: this.helper.outerHeight(),
      };
    },

    _setContainment: function () {
      var over;
      var c;
      var ce;
      var o = this.options;

      if (!o.containment) {
        this.containment = null;
        return;
      }

      if (o.containment === "window") {
        this.containment = [
          $(window).scrollLeft() -
            this.offset.relative.left -
            this.offset.parent.left,
          $(window).scrollTop() -
            this.offset.relative.top -
            this.offset.parent.top,
          $(window).scrollLeft() +
            $(window).width() -
            this.helperProportions.width -
            this.margins.left,
          $(window).scrollTop() +
            ($(window).height() || document.body.parentNode.scrollHeight) -
            this.helperProportions.height -
            this.margins.top,
        ];
        return;
      }

      if (o.containment === "document") {
        this.containment = [
          0,
          0,
          $(document).width() -
            this.helperProportions.width -
            this.margins.left,
          ($(document).height() || document.body.parentNode.scrollHeight) -
            this.helperProportions.height -
            this.margins.top,
        ];
        return;
      }

      if (o.containment.constructor === Array) {
        this.containment = o.containment;
        return;
      }

      if (o.containment === "parent") {
        o.containment = this.helper[0].parentNode;
      }

      c = $(o.containment);
      ce = c[0];

      if (!ce) {
        return;
      }

      over = c.css("overflow") !== "hidden";

      this.containment = [
        (parseInt(c.css("borderLeftWidth"), 10) || 0) +
          (parseInt(c.css("paddingLeft"), 10) || 0),
        (parseInt(c.css("borderTopWidth"), 10) || 0) +
          (parseInt(c.css("paddingTop"), 10) || 0),
        (over ? Math.max(ce.scrollWidth, ce.offsetWidth) : ce.offsetWidth) -
          (parseInt(c.css("borderRightWidth"), 10) || 0) -
          (parseInt(c.css("paddingRight"), 10) || 0) -
          this.helperProportions.width -
          this.margins.left -
          this.margins.right,
        (over ? Math.max(ce.scrollHeight, ce.offsetHeight) : ce.offsetHeight) -
          (parseInt(c.css("borderBottomWidth"), 10) || 0) -
          (parseInt(c.css("paddingBottom"), 10) || 0) -
          this.helperProportions.height -
          this.margins.top -
          this.margins.bottom,
      ];
      this.relative_container = c;
    },

    _convertPositionTo: function (d, pos) {
      if (!pos) {
        pos = this.position;
      }

      var mod = d === "absolute" ? 1 : -1;
      var scroll =
        this.cssPosition === "absolute" &&
        !(
          this.scrollParent[0] !== document &&
          $.contains(this.scrollParent[0], this.offsetParent[0])
        )
          ? this.offsetParent
          : this.scrollParent;

      // Cache the scroll
      if (!this.offset.scroll) {
        this.offset.scroll = {
          top: scroll.scrollTop(),
          left: scroll.scrollLeft(),
        };
      }

      return {
        top:
          pos.top + // The absolute mouse position
          this.offset.relative.top * mod + // Only for relative positioned nodes: Relative offset from element to offset parent
          this.offset.parent.top * mod - // The offsetParent's offset without borders (offset + border)
          (this.cssPosition === "fixed"
            ? -this.scrollParent.scrollTop()
            : this.offset.scroll.top) *
            mod,
        left:
          pos.left + // The absolute mouse position
          this.offset.relative.left * mod + // Only for relative positioned nodes: Relative offset from element to offset parent
          this.offset.parent.left * mod - // The offsetParent's offset without borders (offset + border)
          (this.cssPosition === "fixed"
            ? -this.scrollParent.scrollLeft()
            : this.offset.scroll.left) *
            mod,
      };
    },

    _generatePosition: function (event) {
      var containment;
      var co;
      var top;
      var left;
      var o = this.options;
      var scroll =
        this.cssPosition === "absolute" &&
        !(
          this.scrollParent[0] !== document &&
          $.contains(this.scrollParent[0], this.offsetParent[0])
        )
          ? this.offsetParent
          : this.scrollParent;
      var pageX = event.pageX;
      var pageY = event.pageY;

      // Cache the scroll
      if (!this.offset.scroll) {
        this.offset.scroll = {
          top: scroll.scrollTop(),
          left: scroll.scrollLeft(),
        };
      }

      /*
       * - Position constraining -
       * Constrain the position to a mix of grid, containment.
       */

      // If we are not dragging yet, we won't check for options
      if (this.originalPosition) {
        if (this.containment) {
          if (this.relative_container) {
            co = this.relative_container.offset();
            containment = [
              this.containment[0] + co.left,
              this.containment[1] + co.top,
              this.containment[2] + co.left,
              this.containment[3] + co.top,
            ];
          } else {
            containment = this.containment;
          }

          if (event.pageX - this.offset.click.left < containment[0]) {
            pageX = containment[0] + this.offset.click.left;
          }
          if (event.pageY - this.offset.click.top < containment[1]) {
            pageY = containment[1] + this.offset.click.top;
          }
          if (event.pageX - this.offset.click.left > containment[2]) {
            pageX = containment[2] + this.offset.click.left;
          }
          if (event.pageY - this.offset.click.top > containment[3]) {
            pageY = containment[3] + this.offset.click.top;
          }
        }

        if (o.grid) {
          // Check for grid elements set to 0 to prevent divide by 0 error causing invalid argument errors in IE (see ticket #6950)
          top = o.grid[1]
            ? this.originalPageY +
              Math.round((pageY - this.originalPageY) / o.grid[1]) * o.grid[1]
            : this.originalPageY;
          pageY = containment
            ? top - this.offset.click.top >= containment[1] ||
              top - this.offset.click.top > containment[3]
              ? top
              : top - this.offset.click.top >= containment[1]
              ? top - o.grid[1]
              : top + o.grid[1]
            : top;

          left = o.grid[0]
            ? this.originalPageX +
              Math.round((pageX - this.originalPageX) / o.grid[0]) * o.grid[0]
            : this.originalPageX;
          pageX = containment
            ? left - this.offset.click.left >= containment[0] ||
              left - this.offset.click.left > containment[2]
              ? left
              : left - this.offset.click.left >= containment[0]
              ? left - o.grid[0]
              : left + o.grid[0]
            : left;
        }
      }

      return {
        top:
          pageY - // The absolute mouse position
          this.offset.click.top - // Click offset (relative to the element)
          this.offset.relative.top - // Only for relative positioned nodes: Relative offset from element to offset parent
          this.offset.parent.top + // The offsetParent's offset without borders (offset + border)
          (this.cssPosition === "fixed"
            ? -this.scrollParent.scrollTop()
            : this.offset.scroll.top),
        left:
          pageX - // The absolute mouse position
          this.offset.click.left - // Click offset (relative to the element)
          this.offset.relative.left - // Only for relative positioned nodes: Relative offset from element to offset parent
          this.offset.parent.left + // The offsetParent's offset without borders (offset + border)
          (this.cssPosition === "fixed"
            ? -this.scrollParent.scrollLeft()
            : this.offset.scroll.left),
      };
    },

    _clear: function () {
      this.helper.removeClass("ui-draggable-dragging");
      if (this.helper[0] !== this.element[0] && !this.cancelHelperRemoval) {
        this.helper.remove();
      }
      this.helper = null;
      this.cancelHelperRemoval = false;
    },

    // From now on bulk stuff - mainly helpers

    _trigger: function (type, event, ui) {
      ui = ui || this._uiHash();
      $.ui.plugin.call(this, type, [event, ui]);
      // The absolute position has to be recalculated after plugins
      if (type === "drag") {
        this.positionAbs = this._convertPositionTo("absolute");
      }
      return $.Widget.prototype._trigger.call(this, type, event, ui);
    },

    plugins: {},

    _uiHash: function () {
      return {
        helper: this.helper,
        position: this.position,
        originalPosition: this.originalPosition,
        offset: this.positionAbs,
      };
    },
  });

  $.ui.plugin.add("draggable", "connectToSortable", {
    start: function (event, ui) {
      var inst = $(this).data("ui-draggable");
      var o = inst.options;
      var uiSortable = $.extend({}, ui, { item: inst.element });
      inst.sortables = [];
      $(o.connectToSortable).each(function () {
        var sortable = $.data(this, "ui-sortable");
        if (sortable && !sortable.options.disabled) {
          inst.sortables.push({
            instance: sortable,
            shouldRevert: sortable.options.revert,
          });
          sortable.refreshPositions(); // Call the sortable's refreshPositions at drag start to refresh the containerCache since the sortable container cache is used in drag and needs to be up to date (this will ensure it's initialised as well as being kept in step with any changes that might have happened on the page).
          sortable._trigger("activate", event, uiSortable);
        }
      });
    },
    stop: function (event, ui) {
      // If we are still over the sortable, we fake the stop event of the sortable, but also remove helper
      var inst = $(this).data("ui-draggable");
      var uiSortable = $.extend({}, ui, { item: inst.element });

      $.each(inst.sortables, function () {
        if (this.instance.isOver) {
          this.instance.isOver = 0;

          inst.cancelHelperRemoval = true; // Don't remove the helper in the draggable instance
          this.instance.cancelHelperRemoval = false; // Remove it in the sortable instance (so sortable plugins like revert still work)

          // The sortable revert is supported, and we have to set a temporary dropped variable on the draggable to support revert: "valid/invalid"
          if (this.shouldRevert) {
            this.instance.options.revert = this.shouldRevert;
          }

          // Trigger the stop of the sortable
          this.instance._mouseStop(event);

          this.instance.options.helper = this.instance.options._helper;

          // If the helper has been the original item, restore properties in the sortable
          if (inst.options.helper === "original") {
            this.instance.currentItem.css({ top: "auto", left: "auto" });
          }
        } else {
          this.instance.cancelHelperRemoval = false; // Remove the helper in the sortable instance
          this.instance._trigger("deactivate", event, uiSortable);
        }
      });
    },
    drag: function (event, ui) {
      var inst = $(this).data("ui-draggable");
      var that = this;

      $.each(inst.sortables, function () {
        var innermostIntersecting = false;
        var thisSortable = this;

        // Copy over some variables to allow calling the sortable's native _intersectsWith
        this.instance.positionAbs = inst.positionAbs;
        this.instance.helperProportions = inst.helperProportions;
        this.instance.offset.click = inst.offset.click;

        if (this.instance._intersectsWith(this.instance.containerCache)) {
          innermostIntersecting = true;
          $.each(inst.sortables, function () {
            this.instance.positionAbs = inst.positionAbs;
            this.instance.helperProportions = inst.helperProportions;
            this.instance.offset.click = inst.offset.click;
            if (
              this !== thisSortable &&
              this.instance._intersectsWith(this.instance.containerCache) &&
              $.contains(
                thisSortable.instance.element[0],
                this.instance.element[0]
              )
            ) {
              innermostIntersecting = false;
            }
            return innermostIntersecting;
          });
        }

        if (innermostIntersecting) {
          // If it intersects, we use a little isOver variable and set it once, so our move-in stuff gets fired only once
          if (!this.instance.isOver) {
            this.instance.isOver = 1;
            // Now we fake the start of dragging for the sortable instance,
            // by cloning the list group item, appending it to the sortable and using it as inst.currentItem
            // We can then fire the start event of the sortable with our passed browser event, and our own helper (so it doesn't create a new one)
            this.instance.currentItem = $(that)
              .clone()
              .removeAttr("id")
              .appendTo(this.instance.element)
              .data("ui-sortable-item", true);
            this.instance.options._helper = this.instance.options.helper; // Store helper option to later restore it
            this.instance.options.helper = function () {
              return ui.helper[0];
            };

            event.target = this.instance.currentItem[0];
            this.instance._mouseCapture(event, true);
            this.instance._mouseStart(event, true, true);

            // Because the browser event is way off the new appended portlet, we modify a couple of variables to reflect the changes
            this.instance.offset.click.top = inst.offset.click.top;
            this.instance.offset.click.left = inst.offset.click.left;
            this.instance.offset.parent.left -=
              inst.offset.parent.left - this.instance.offset.parent.left;
            this.instance.offset.parent.top -=
              inst.offset.parent.top - this.instance.offset.parent.top;

            inst._trigger("toSortable", event);
            inst.dropped = this.instance.element; // draggable revert needs that
            // hack so receive/update callbacks work (mostly)
            inst.currentItem = inst.element;
            this.instance.fromOutside = inst;
          }

          // Provided we did all the previous steps, we can fire the drag event of the sortable on every draggable drag, when it intersects with the sortable
          if (this.instance.currentItem) {
            this.instance._mouseDrag(event);
          }
        } else {
          // If it doesn't intersect with the sortable, and it intersected before,
          // we fake the drag stop of the sortable, but make sure it doesn't remove the helper by using cancelHelperRemoval
          if (this.instance.isOver) {
            this.instance.isOver = 0;
            this.instance.cancelHelperRemoval = true;

            // Prevent reverting on this forced stop
            this.instance.options.revert = false;

            // The out event needs to be triggered independently
            this.instance._trigger(
              "out",
              event,
              this.instance._uiHash(this.instance)
            );

            this.instance._mouseStop(event, true);
            this.instance.options.helper = this.instance.options._helper;

            // Now we remove our currentItem, the list group clone again, and the placeholder, and animate the helper back to it's original size
            this.instance.currentItem.remove();
            if (this.instance.placeholder) {
              this.instance.placeholder.remove();
            }

            inst._trigger("fromSortable", event);
            inst.dropped = false; // draggable revert needs that
          }
        }
      });
    },
  });

  $.ui.plugin.add("draggable", "cursor", {
    start: function () {
      var t = $("body");
      var o = $(this).data("ui-draggable").options;
      if (t.css("cursor")) {
        o._cursor = t.css("cursor");
      }
      t.css("cursor", o.cursor);
    },
    stop: function () {
      var o = $(this).data("ui-draggable").options;
      if (o._cursor) {
        $("body").css("cursor", o._cursor);
      }
    },
  });

  $.ui.plugin.add("draggable", "opacity", {
    start: function (event, ui) {
      var t = $(ui.helper);
      var o = $(this).data("ui-draggable").options;
      if (t.css("opacity")) {
        o._opacity = t.css("opacity");
      }
      t.css("opacity", o.opacity);
    },
    stop: function (event, ui) {
      var o = $(this).data("ui-draggable").options;
      if (o._opacity) {
        $(ui.helper).css("opacity", o._opacity);
      }
    },
  });

  $.ui.plugin.add("draggable", "scroll", {
    start: function () {
      var i = $(this).data("ui-draggable");
      if (
        i.scrollParent[0] !== document &&
        i.scrollParent[0].tagName !== "HTML"
      ) {
        i.overflowOffset = i.scrollParent.offset();
      }
    },
    drag: function (event) {
      var i = $(this).data("ui-draggable");
      var o = i.options;
      var scrolled = false;

      if (
        i.scrollParent[0] !== document &&
        i.scrollParent[0].tagName !== "HTML"
      ) {
        if (!o.axis || o.axis !== "x") {
          if (
            i.overflowOffset.top +
              i.scrollParent[0].offsetHeight -
              event.pageY <
            o.scrollSensitivity
          ) {
            i.scrollParent[0].scrollTop = scrolled =
              i.scrollParent[0].scrollTop + o.scrollSpeed;
          } else if (event.pageY - i.overflowOffset.top < o.scrollSensitivity) {
            i.scrollParent[0].scrollTop = scrolled =
              i.scrollParent[0].scrollTop - o.scrollSpeed;
          }
        }

        if (!o.axis || o.axis !== "y") {
          if (
            i.overflowOffset.left +
              i.scrollParent[0].offsetWidth -
              event.pageX <
            o.scrollSensitivity
          ) {
            i.scrollParent[0].scrollLeft = scrolled =
              i.scrollParent[0].scrollLeft + o.scrollSpeed;
          } else if (
            event.pageX - i.overflowOffset.left <
            o.scrollSensitivity
          ) {
            i.scrollParent[0].scrollLeft = scrolled =
              i.scrollParent[0].scrollLeft - o.scrollSpeed;
          }
        }
      } else {
        if (!o.axis || o.axis !== "x") {
          if (event.pageY - $(document).scrollTop() < o.scrollSensitivity) {
            scrolled = $(document).scrollTop(
              $(document).scrollTop() - o.scrollSpeed
            );
          } else if (
            $(window).height() - (event.pageY - $(document).scrollTop()) <
            o.scrollSensitivity
          ) {
            scrolled = $(document).scrollTop(
              $(document).scrollTop() + o.scrollSpeed
            );
          }
        }

        if (!o.axis || o.axis !== "y") {
          if (event.pageX - $(document).scrollLeft() < o.scrollSensitivity) {
            scrolled = $(document).scrollLeft(
              $(document).scrollLeft() - o.scrollSpeed
            );
          } else if (
            $(window).width() - (event.pageX - $(document).scrollLeft()) <
            o.scrollSensitivity
          ) {
            scrolled = $(document).scrollLeft(
              $(document).scrollLeft() + o.scrollSpeed
            );
          }
        }
      }

      if (scrolled !== false && $.ui.ddmanager && !o.dropBehaviour) {
        $.ui.ddmanager.prepareOffsets(i, event);
      }
    },
  });

  $.ui.plugin.add("draggable", "snap", {
    start: function () {
      var i = $(this).data("ui-draggable");
      var o = i.options;

      i.snapElements = [];

      $(
        o.snap.constructor !== String
          ? o.snap.items || ":data(ui-draggable)"
          : o.snap
      ).each(function () {
        var $t = $(this);
        var $o = $t.offset();
        if (this !== i.element[0]) {
          i.snapElements.push({
            item: this,
            width: $t.outerWidth(),
            height: $t.outerHeight(),
            top: $o.top,
            left: $o.left,
          });
        }
      });
    },
    drag: function (event, ui) {
      var ts;
      var bs;
      var ls;
      var rs;
      var l;
      var r;
      var t;
      var b;
      var i;
      var first;
      var inst = $(this).data("ui-draggable");
      var o = inst.options;
      var d = o.snapTolerance;
      var x1 = ui.offset.left;
      var x2 = x1 + inst.helperProportions.width;
      var y1 = ui.offset.top;
      var y2 = y1 + inst.helperProportions.height;

      for (i = inst.snapElements.length - 1; i >= 0; i--) {
        l = inst.snapElements[i].left;
        r = l + inst.snapElements[i].width;
        t = inst.snapElements[i].top;
        b = t + inst.snapElements[i].height;

        if (
          x2 < l - d ||
          x1 > r + d ||
          y2 < t - d ||
          y1 > b + d ||
          !$.contains(
            inst.snapElements[i].item.ownerDocument,
            inst.snapElements[i].item
          )
        ) {
          if (inst.snapElements[i].snapping) {
            inst.options.snap.release &&
              inst.options.snap.release.call(
                inst.element,
                event,
                $.extend(inst._uiHash(), {
                  snapItem: inst.snapElements[i].item,
                })
              );
          }
          inst.snapElements[i].snapping = false;
          continue;
        }

        if (o.snapMode !== "inner") {
          ts = Math.abs(t - y2) <= d;
          bs = Math.abs(b - y1) <= d;
          ls = Math.abs(l - x2) <= d;
          rs = Math.abs(r - x1) <= d;
          if (ts) {
            ui.position.top =
              inst._convertPositionTo("relative", {
                top: t - inst.helperProportions.height,
                left: 0,
              }).top - inst.margins.top;
          }
          if (bs) {
            ui.position.top =
              inst._convertPositionTo("relative", { top: b, left: 0 }).top -
              inst.margins.top;
          }
          if (ls) {
            ui.position.left =
              inst._convertPositionTo("relative", {
                top: 0,
                left: l - inst.helperProportions.width,
              }).left - inst.margins.left;
          }
          if (rs) {
            ui.position.left =
              inst._convertPositionTo("relative", { top: 0, left: r }).left -
              inst.margins.left;
          }
        }

        first = ts || bs || ls || rs;

        if (o.snapMode !== "outer") {
          ts = Math.abs(t - y1) <= d;
          bs = Math.abs(b - y2) <= d;
          ls = Math.abs(l - x1) <= d;
          rs = Math.abs(r - x2) <= d;
          if (ts) {
            ui.position.top =
              inst._convertPositionTo("relative", { top: t, left: 0 }).top -
              inst.margins.top;
          }
          if (bs) {
            ui.position.top =
              inst._convertPositionTo("relative", {
                top: b - inst.helperProportions.height,
                left: 0,
              }).top - inst.margins.top;
          }
          if (ls) {
            ui.position.left =
              inst._convertPositionTo("relative", { top: 0, left: l }).left -
              inst.margins.left;
          }
          if (rs) {
            ui.position.left =
              inst._convertPositionTo("relative", {
                top: 0,
                left: r - inst.helperProportions.width,
              }).left - inst.margins.left;
          }
        }

        if (!inst.snapElements[i].snapping && (ts || bs || ls || rs || first)) {
          inst.options.snap.snap &&
            inst.options.snap.snap.call(
              inst.element,
              event,
              $.extend(inst._uiHash(), { snapItem: inst.snapElements[i].item })
            );
        }
        inst.snapElements[i].snapping = ts || bs || ls || rs || first;
      }
    },
  });

  $.ui.plugin.add("draggable", "stack", {
    start: function () {
      var min;
      var o = this.data("ui-draggable").options;
      var group = $.makeArray($(o.stack)).sort(function (a, b) {
        return (
          (parseInt($(a).css("zIndex"), 10) || 0) -
          (parseInt($(b).css("zIndex"), 10) || 0)
        );
      });

      if (!group.length) {
        return;
      }

      min = parseInt($(group[0]).css("zIndex"), 10) || 0;
      $(group).each(function (i) {
        $(this).css("zIndex", min + i);
      });
      this.css("zIndex", min + group.length);
    },
  });

  $.ui.plugin.add("draggable", "zIndex", {
    start: function (event, ui) {
      var t = $(ui.helper);
      var o = $(this).data("ui-draggable").options;
      if (t.css("zIndex")) {
        o._zIndex = t.css("zIndex");
      }
      t.css("zIndex", o.zIndex);
    },
    stop: function (event, ui) {
      var o = $(this).data("ui-draggable").options;
      if (o._zIndex) {
        $(ui.helper).css("zIndex", o._zIndex);
      }
    },
  });
})(jQuery);
(function ($, undefined) {
  function isOverAxis(x, reference, size) {
    return x > reference && x < reference + size;
  }

  $.widget("ui.droppable", {
    version: "1.10.3",
    widgetEventPrefix: "drop",
    options: {
      accept: "*",
      activeClass: false,
      addClasses: true,
      greedy: false,
      hoverClass: false,
      scope: "default",
      tolerance: "intersect",

      // callbacks
      activate: null,
      deactivate: null,
      drop: null,
      out: null,
      over: null,
    },
    _create: function () {
      var o = this.options;
      var accept = o.accept;

      this.isover = false;
      this.isout = true;

      this.accept = $.isFunction(accept)
        ? accept
        : function (d) {
            return d.is(accept);
          };

      // Store the droppable's proportions
      this.proportions = {
        width: this.element[0].offsetWidth,
        height: this.element[0].offsetHeight,
      };

      // Add the reference and positions to the manager
      $.ui.ddmanager.droppables[o.scope] =
        $.ui.ddmanager.droppables[o.scope] || [];
      $.ui.ddmanager.droppables[o.scope].push(this);

      o.addClasses && this.element.addClass("ui-droppable");
    },

    _destroy: function () {
      var i = 0;
      var drop = $.ui.ddmanager.droppables[this.options.scope];

      for (; i < drop.length; i++) {
        if (drop[i] === this) {
          drop.splice(i, 1);
        }
      }

      this.element.removeClass("ui-droppable ui-droppable-disabled");
    },

    _setOption: function (key, value) {
      if (key === "accept") {
        this.accept = $.isFunction(value)
          ? value
          : function (d) {
              return d.is(value);
            };
      }
      $.Widget.prototype._setOption.apply(this, arguments);
    },

    _activate: function (event) {
      var draggable = $.ui.ddmanager.current;
      if (this.options.activeClass) {
        this.element.addClass(this.options.activeClass);
      }
      if (draggable) {
        this._trigger("activate", event, this.ui(draggable));
      }
    },

    _deactivate: function (event) {
      var draggable = $.ui.ddmanager.current;
      if (this.options.activeClass) {
        this.element.removeClass(this.options.activeClass);
      }
      if (draggable) {
        this._trigger("deactivate", event, this.ui(draggable));
      }
    },

    _over: function (event) {
      var draggable = $.ui.ddmanager.current;

      // Bail if draggable and droppable are same element
      if (
        !draggable ||
        (draggable.currentItem || draggable.element)[0] === this.element[0]
      ) {
        return;
      }

      if (
        this.accept.call(
          this.element[0],
          draggable.currentItem || draggable.element
        )
      ) {
        if (this.options.hoverClass) {
          this.element.addClass(this.options.hoverClass);
        }
        this._trigger("over", event, this.ui(draggable));
      }
    },

    _out: function (event) {
      var draggable = $.ui.ddmanager.current;

      // Bail if draggable and droppable are same element
      if (
        !draggable ||
        (draggable.currentItem || draggable.element)[0] === this.element[0]
      ) {
        return;
      }

      if (
        this.accept.call(
          this.element[0],
          draggable.currentItem || draggable.element
        )
      ) {
        if (this.options.hoverClass) {
          this.element.removeClass(this.options.hoverClass);
        }
        this._trigger("out", event, this.ui(draggable));
      }
    },

    _drop: function (event, custom) {
      var draggable = custom || $.ui.ddmanager.current;
      var childrenIntersection = false;

      // Bail if draggable and droppable are same element
      if (
        !draggable ||
        (draggable.currentItem || draggable.element)[0] === this.element[0]
      ) {
        return false;
      }

      this.element
        .find(":data(ui-droppable)")
        .not(".ui-draggable-dragging")
        .each(function () {
          var inst = $.data(this, "ui-droppable");
          if (
            inst.options.greedy &&
            !inst.options.disabled &&
            inst.options.scope === draggable.options.scope &&
            inst.accept.call(
              inst.element[0],
              draggable.currentItem || draggable.element
            ) &&
            $.ui.intersect(
              draggable,
              $.extend(inst, { offset: inst.element.offset() }),
              inst.options.tolerance
            )
          ) {
            childrenIntersection = true;
            return false;
          }
        });
      if (childrenIntersection) {
        return false;
      }

      if (
        this.accept.call(
          this.element[0],
          draggable.currentItem || draggable.element
        )
      ) {
        if (this.options.activeClass) {
          this.element.removeClass(this.options.activeClass);
        }
        if (this.options.hoverClass) {
          this.element.removeClass(this.options.hoverClass);
        }
        this._trigger("drop", event, this.ui(draggable));
        return this.element;
      }

      return false;
    },

    ui: function (c) {
      return {
        draggable: c.currentItem || c.element,
        helper: c.helper,
        position: c.position,
        offset: c.positionAbs,
      };
    },
  });

  $.ui.intersect = function (draggable, droppable, toleranceMode) {
    if (!droppable.offset) {
      return false;
    }

    var draggableLeft;
    var draggableTop;
    var x1 = (draggable.positionAbs || draggable.position.absolute).left;
    var x2 = x1 + draggable.helperProportions.width;
    var y1 = (draggable.positionAbs || draggable.position.absolute).top;
    var y2 = y1 + draggable.helperProportions.height;
    var l = droppable.offset.left;
    var r = l + droppable.proportions.width;
    var t = droppable.offset.top;
    var b = t + droppable.proportions.height;

    switch (toleranceMode) {
      case "fit":
        return l <= x1 && x2 <= r && t <= y1 && y2 <= b;
      case "intersect":
        return (
          l < x1 + draggable.helperProportions.width / 2 && // Right Half
          x2 - draggable.helperProportions.width / 2 < r && // Left Half
          t < y1 + draggable.helperProportions.height / 2 && // Bottom Half
          y2 - draggable.helperProportions.height / 2 < b
        ); // Top Half
      case "pointer":
        draggableLeft =
          (draggable.positionAbs || draggable.position.absolute).left +
          (draggable.clickOffset || draggable.offset.click).left;
        draggableTop =
          (draggable.positionAbs || draggable.position.absolute).top +
          (draggable.clickOffset || draggable.offset.click).top;
        return (
          isOverAxis(draggableTop, t, droppable.proportions.height) &&
          isOverAxis(draggableLeft, l, droppable.proportions.width)
        );
      case "touch":
        return (
          ((y1 >= t && y1 <= b) || // Top edge touching
            (y2 >= t && y2 <= b) || // Bottom edge touching
            (y1 < t && y2 > b)) && // Surrounded vertically
          ((x1 >= l && x1 <= r) || // Left edge touching
            (x2 >= l && x2 <= r) || // Right edge touching
            (x1 < l && x2 > r)) // Surrounded horizontally
        );
      default:
        return false;
    }
  };

  /*
  This manager tracks offsets of draggables and droppables
*/
  $.ui.ddmanager = {
    current: null,
    droppables: { default: [] },
    prepareOffsets: function (t, event) {
      var i;
      var j;
      var m = $.ui.ddmanager.droppables[t.options.scope] || [];
      var type = event ? event.type : null; // workaround for #2317
      var list = (t.currentItem || t.element)
        .find(":data(ui-droppable)")
        .addBack();

      droppablesLoop: for (i = 0; i < m.length; i++) {
        // No disabled and non-accepted
        if (
          m[i].options.disabled ||
          (t && !m[i].accept.call(m[i].element[0], t.currentItem || t.element))
        ) {
          continue;
        }

        // Filter out elements in the current dragged item
        for (j = 0; j < list.length; j++) {
          if (list[j] === m[i].element[0]) {
            m[i].proportions.height = 0;
            continue droppablesLoop;
          }
        }

        m[i].visible = m[i].element.css("display") !== "none";
        if (!m[i].visible) {
          continue;
        }

        // Activate the droppable if used directly from draggables
        if (type === "mousedown") {
          m[i]._activate.call(m[i], event);
        }

        m[i].offset = m[i].element.offset();
        m[i].proportions = {
          width: m[i].element[0].offsetWidth,
          height: m[i].element[0].offsetHeight,
        };
      }
    },
    drop: function (draggable, event) {
      var dropped = false;
      // Create a copy of the droppables in case the list changes during the drop (#9116)
      $.each(
        ($.ui.ddmanager.droppables[draggable.options.scope] || []).slice(),
        function () {
          if (!this.options) {
            return;
          }
          if (
            !this.options.disabled &&
            this.visible &&
            $.ui.intersect(draggable, this, this.options.tolerance)
          ) {
            dropped = this._drop.call(this, event) || dropped;
          }

          if (
            !this.options.disabled &&
            this.visible &&
            this.accept.call(
              this.element[0],
              draggable.currentItem || draggable.element
            )
          ) {
            this.isout = true;
            this.isover = false;
            this._deactivate.call(this, event);
          }
        }
      );
      return dropped;
    },
    dragStart: function (draggable, event) {
      // Listen for scrolling so that if the dragging causes scrolling the position of the droppables can be recalculated (see #5003)
      draggable.element
        .parentsUntil("body")
        .bind("scroll.droppable", function () {
          if (!draggable.options.refreshPositions) {
            $.ui.ddmanager.prepareOffsets(draggable, event);
          }
        });
    },
    drag: function (draggable, event) {
      // If you have a highly dynamic page, you might try this option. It renders positions every time you move the mouse.
      if (draggable.options.refreshPositions) {
        $.ui.ddmanager.prepareOffsets(draggable, event);
      }

      // Run through all droppables and check their positions based on specific tolerance options
      $.each(
        $.ui.ddmanager.droppables[draggable.options.scope] || [],
        function () {
          if (this.options.disabled || this.greedyChild || !this.visible) {
            return;
          }

          var parentInstance;
          var scope;
          var parent;
          var intersects = $.ui.intersect(
            draggable,
            this,
            this.options.tolerance
          );
          var c =
            !intersects && this.isover
              ? "isout"
              : intersects && !this.isover
              ? "isover"
              : null;
          if (!c) {
            return;
          }

          if (this.options.greedy) {
            // find droppable parents with same scope
            scope = this.options.scope;
            parent = this.element
              .parents(":data(ui-droppable)")
              .filter(function () {
                return $.data(this, "ui-droppable").options.scope === scope;
              });

            if (parent.length) {
              parentInstance = $.data(parent[0], "ui-droppable");
              parentInstance.greedyChild = c === "isover";
            }
          }

          // we just moved into a greedy child
          if (parentInstance && c === "isover") {
            parentInstance.isover = false;
            parentInstance.isout = true;
            parentInstance._out.call(parentInstance, event);
          }

          this[c] = true;
          this[c === "isout" ? "isover" : "isout"] = false;
          this[c === "isover" ? "_over" : "_out"].call(this, event);

          // we just moved out of a greedy child
          if (parentInstance && c === "isout") {
            parentInstance.isout = false;
            parentInstance.isover = true;
            parentInstance._over.call(parentInstance, event);
          }
        }
      );
    },
    dragStop: function (draggable, event) {
      draggable.element.parentsUntil("body").unbind("scroll.droppable");
      // Call prepareOffsets one final time since IE does not fire return scroll events when overflow was caused by drag (see #5003)
      if (!draggable.options.refreshPositions) {
        $.ui.ddmanager.prepareOffsets(draggable, event);
      }
    },
  };
})(jQuery);
(function ($, undefined) {
  /* jshint loopfunc: true */

  function isOverAxis(x, reference, size) {
    return x > reference && x < reference + size;
  }

  function isFloating(item) {
    return (
      /left|right/.test(item.css("float")) ||
      /inline|table-cell/.test(item.css("display"))
    );
  }

  $.widget("ui.sortable", $.ui.mouse, {
    version: "1.10.3",
    widgetEventPrefix: "sort",
    ready: false,
    options: {
      appendTo: "parent",
      axis: false,
      connectWith: false,
      containment: false,
      cursor: "auto",
      cursorAt: false,
      dropOnEmpty: true,
      forcePlaceholderSize: false,
      forceHelperSize: false,
      grid: false,
      handle: false,
      helper: "original",
      items: "> *",
      opacity: false,
      placeholder: false,
      revert: false,
      scroll: true,
      scrollSensitivity: 20,
      scrollSpeed: 20,
      scope: "default",
      tolerance: "intersect",
      zIndex: 1000,

      // callbacks
      activate: null,
      beforeStop: null,
      change: null,
      deactivate: null,
      out: null,
      over: null,
      receive: null,
      remove: null,
      sort: null,
      start: null,
      stop: null,
      update: null,
    },
    _create: function () {
      var o = this.options;
      this.containerCache = {};
      this.element.addClass("ui-sortable");

      // Get the items
      this.refresh();

      // Let's determine if the items are being displayed horizontally
      this.floating = this.items.length
        ? o.axis === "x" || isFloating(this.items[0].item)
        : false;

      // Let's determine the parent's offset
      this.offset = this.element.offset();

      // Initialize mouse events for interaction
      this._mouseInit();

      // We're ready to go
      this.ready = true;
    },

    _destroy: function () {
      this.element.removeClass("ui-sortable ui-sortable-disabled");
      this._mouseDestroy();

      for (var i = this.items.length - 1; i >= 0; i--) {
        this.items[i].item.removeData(this.widgetName + "-item");
      }

      return this;
    },

    _setOption: function (key, value) {
      if (key === "disabled") {
        this.options[key] = value;

        this.widget().toggleClass("ui-sortable-disabled", !!value);
      } else {
        // Don't call widget base _setOption for disable as it adds ui-state-disabled class
        $.Widget.prototype._setOption.apply(this, arguments);
      }
    },

    _mouseCapture: function (event, overrideHandle) {
      var currentItem = null;
      var validHandle = false;
      var that = this;

      if (this.reverting) {
        return false;
      }

      if (this.options.disabled || this.options.type === "static") {
        return false;
      }

      // We have to refresh the items data once first
      this._refreshItems(event);

      // Find out if the clicked node (or one of its parents) is a actual item in this.items
      $(event.target)
        .parents()
        .each(function () {
          if ($.data(this, that.widgetName + "-item") === that) {
            currentItem = $(this);
            return false;
          }
        });
      if ($.data(event.target, that.widgetName + "-item") === that) {
        currentItem = $(event.target);
      }

      if (!currentItem) {
        return false;
      }
      if (this.options.handle && !overrideHandle) {
        $(this.options.handle, currentItem)
          .find("*")
          .addBack()
          .each(function () {
            if (this === event.target) {
              validHandle = true;
            }
          });
        if (!validHandle) {
          return false;
        }
      }

      this.currentItem = currentItem;
      this._removeCurrentsFromItems();
      return true;
    },

    _mouseStart: function (event, overrideHandle, noActivation) {
      var i;
      var body;
      var o = this.options;

      this.currentContainer = this;

      // We only need to call refreshPositions, because the refreshItems call has been moved to mouseCapture
      this.refreshPositions();

      // Create and append the visible helper
      this.helper = this._createHelper(event);

      // Cache the helper size
      this._cacheHelperProportions();

      /*
       * - Position generation -
       * This block generates everything position related - it's the core of draggables.
       */

      // Cache the margins of the original element
      this._cacheMargins();

      // Get the next scrolling parent
      this.scrollParent = this.helper.scrollParent();

      // The element's absolute position on the page minus margins
      this.offset = this.currentItem.offset();
      this.offset = {
        top: this.offset.top - this.margins.top,
        left: this.offset.left - this.margins.left,
      };

      $.extend(this.offset, {
        click: {
          // Where the click happened, relative to the element
          left: event.pageX - this.offset.left,
          top: event.pageY - this.offset.top,
        },
        parent: this._getParentOffset(),
        relative: this._getRelativeOffset(), // This is a relative to absolute position minus the actual position calculation - only used for relative positioned helper
      });

      // Only after we got the offset, we can change the helper's position to absolute
      // TODO: Still need to figure out a way to make relative sorting possible
      this.helper.css("position", "absolute");
      this.cssPosition = this.helper.css("position");

      // Generate the original position
      this.originalPosition = this._generatePosition(event);
      this.originalPageX = event.pageX;
      this.originalPageY = event.pageY;

      // Adjust the mouse offset relative to the helper if "cursorAt" is supplied
      o.cursorAt && this._adjustOffsetFromHelper(o.cursorAt);

      // Cache the former DOM position
      this.domPosition = {
        prev: this.currentItem.prev()[0],
        parent: this.currentItem.parent()[0],
      };

      // If the helper is not the original, hide the original so it's not playing any role during the drag, won't cause anything bad this way
      if (this.helper[0] !== this.currentItem[0]) {
        this.currentItem.hide();
      }

      // Create the placeholder
      this._createPlaceholder();

      // Set a containment if given in the options
      if (o.containment) {
        this._setContainment();
      }

      if (o.cursor && o.cursor !== "auto") {
        // cursor option
        body = this.document.find("body");

        // support: IE
        this.storedCursor = body.css("cursor");
        body.css("cursor", o.cursor);

        this.storedStylesheet = $(
          "<style>*{ cursor: " + o.cursor + " !important; }</style>"
        ).appendTo(body);
      }

      if (o.opacity) {
        // opacity option
        if (this.helper.css("opacity")) {
          this._storedOpacity = this.helper.css("opacity");
        }
        this.helper.css("opacity", o.opacity);
      }

      if (o.zIndex) {
        // zIndex option
        if (this.helper.css("zIndex")) {
          this._storedZIndex = this.helper.css("zIndex");
        }
        this.helper.css("zIndex", o.zIndex);
      }

      // Prepare scrolling
      if (
        this.scrollParent[0] !== document &&
        this.scrollParent[0].tagName !== "HTML"
      ) {
        this.overflowOffset = this.scrollParent.offset();
      }

      // Call callbacks
      this._trigger("start", event, this._uiHash());

      // Recache the helper size
      if (!this._preserveHelperProportions) {
        this._cacheHelperProportions();
      }

      // Post "activate" events to possible containers
      if (!noActivation) {
        for (i = this.containers.length - 1; i >= 0; i--) {
          this.containers[i]._trigger("activate", event, this._uiHash(this));
        }
      }

      // Prepare possible droppables
      if ($.ui.ddmanager) {
        $.ui.ddmanager.current = this;
      }

      if ($.ui.ddmanager && !o.dropBehaviour) {
        $.ui.ddmanager.prepareOffsets(this, event);
      }

      this.dragging = true;

      this.helper.addClass("ui-sortable-helper");
      this._mouseDrag(event); // Execute the drag once - this causes the helper not to be visible before getting its correct position
      return true;
    },

    _mouseDrag: function (event) {
      var i;
      var item;
      var itemElement;
      var intersection;
      var o = this.options;
      var scrolled = false;

      // Compute the helpers position
      this.position = this._generatePosition(event);
      this.positionAbs = this._convertPositionTo("absolute");

      if (!this.lastPositionAbs) {
        this.lastPositionAbs = this.positionAbs;
      }

      // Do scrolling
      if (this.options.scroll) {
        if (
          this.scrollParent[0] !== document &&
          this.scrollParent[0].tagName !== "HTML"
        ) {
          if (
            this.overflowOffset.top +
              this.scrollParent[0].offsetHeight -
              event.pageY <
            o.scrollSensitivity
          ) {
            this.scrollParent[0].scrollTop = scrolled =
              this.scrollParent[0].scrollTop + o.scrollSpeed;
          } else if (
            event.pageY - this.overflowOffset.top <
            o.scrollSensitivity
          ) {
            this.scrollParent[0].scrollTop = scrolled =
              this.scrollParent[0].scrollTop - o.scrollSpeed;
          }

          if (
            this.overflowOffset.left +
              this.scrollParent[0].offsetWidth -
              event.pageX <
            o.scrollSensitivity
          ) {
            this.scrollParent[0].scrollLeft = scrolled =
              this.scrollParent[0].scrollLeft + o.scrollSpeed;
          } else if (
            event.pageX - this.overflowOffset.left <
            o.scrollSensitivity
          ) {
            this.scrollParent[0].scrollLeft = scrolled =
              this.scrollParent[0].scrollLeft - o.scrollSpeed;
          }
        } else {
          if (event.pageY - $(document).scrollTop() < o.scrollSensitivity) {
            scrolled = $(document).scrollTop(
              $(document).scrollTop() - o.scrollSpeed
            );
          } else if (
            $(window).height() - (event.pageY - $(document).scrollTop()) <
            o.scrollSensitivity
          ) {
            scrolled = $(document).scrollTop(
              $(document).scrollTop() + o.scrollSpeed
            );
          }

          if (event.pageX - $(document).scrollLeft() < o.scrollSensitivity) {
            scrolled = $(document).scrollLeft(
              $(document).scrollLeft() - o.scrollSpeed
            );
          } else if (
            $(window).width() - (event.pageX - $(document).scrollLeft()) <
            o.scrollSensitivity
          ) {
            scrolled = $(document).scrollLeft(
              $(document).scrollLeft() + o.scrollSpeed
            );
          }
        }

        if (scrolled !== false && $.ui.ddmanager && !o.dropBehaviour) {
          $.ui.ddmanager.prepareOffsets(this, event);
        }
      }

      // Regenerate the absolute position used for position checks
      this.positionAbs = this._convertPositionTo("absolute");

      // Set the helper position
      if (!this.options.axis || this.options.axis !== "y") {
        this.helper[0].style.left = this.position.left + "px";
      }
      if (!this.options.axis || this.options.axis !== "x") {
        this.helper[0].style.top = this.position.top + "px";
      }

      // Rearrange
      for (i = this.items.length - 1; i >= 0; i--) {
        // Cache variables and intersection, continue if no intersection
        item = this.items[i];
        itemElement = item.item[0];
        intersection = this._intersectsWithPointer(item);
        if (!intersection) {
          continue;
        }

        // Only put the placeholder inside the current Container, skip all
        // items form other containers. This works because when moving
        // an item from one container to another the
        // currentContainer is switched before the placeholder is moved.
        //
        // Without this moving items in "sub-sortables" can cause the placeholder to jitter
        // beetween the outer and inner container.
        if (item.instance !== this.currentContainer) {
          continue;
        }

        // cannot intersect with itself
        // no useless actions that have been done before
        // no action if the item moved is the parent of the item checked
        if (
          itemElement !== this.currentItem[0] &&
          this.placeholder[intersection === 1 ? "next" : "prev"]()[0] !==
            itemElement &&
          !$.contains(this.placeholder[0], itemElement) &&
          (this.options.type === "semi-dynamic"
            ? !$.contains(this.element[0], itemElement)
            : true)
        ) {
          this.direction = intersection === 1 ? "down" : "up";

          if (
            this.options.tolerance === "pointer" ||
            this._intersectsWithSides(item)
          ) {
            this._rearrange(event, item);
          } else {
            break;
          }

          this._trigger("change", event, this._uiHash());
          break;
        }
      }

      // Post events to containers
      this._contactContainers(event);

      // Interconnect with droppables
      if ($.ui.ddmanager) {
        $.ui.ddmanager.drag(this, event);
      }

      // Call callbacks
      this._trigger("sort", event, this._uiHash());

      this.lastPositionAbs = this.positionAbs;
      return false;
    },

    _mouseStop: function (event, noPropagation) {
      if (!event) {
        return;
      }

      // If we are using droppables, inform the manager about the drop
      if ($.ui.ddmanager && !this.options.dropBehaviour) {
        $.ui.ddmanager.drop(this, event);
      }

      if (this.options.revert) {
        var that = this;
        var cur = this.placeholder.offset();
        var axis = this.options.axis;
        var animation = {};

        if (!axis || axis === "x") {
          animation.left =
            cur.left -
            this.offset.parent.left -
            this.margins.left +
            (this.offsetParent[0] === document.body
              ? 0
              : this.offsetParent[0].scrollLeft);
        }
        if (!axis || axis === "y") {
          animation.top =
            cur.top -
            this.offset.parent.top -
            this.margins.top +
            (this.offsetParent[0] === document.body
              ? 0
              : this.offsetParent[0].scrollTop);
        }
        this.reverting = true;
        $(this.helper).animate(
          animation,
          parseInt(this.options.revert, 10) || 500,
          function () {
            that._clear(event);
          }
        );
      } else {
        this._clear(event, noPropagation);
      }

      return false;
    },

    cancel: function () {
      if (this.dragging) {
        this._mouseUp({ target: null });

        if (this.options.helper === "original") {
          this.currentItem
            .css(this._storedCSS)
            .removeClass("ui-sortable-helper");
        } else {
          this.currentItem.show();
        }

        // Post deactivating events to containers
        for (var i = this.containers.length - 1; i >= 0; i--) {
          this.containers[i]._trigger("deactivate", null, this._uiHash(this));
          if (this.containers[i].containerCache.over) {
            this.containers[i]._trigger("out", null, this._uiHash(this));
            this.containers[i].containerCache.over = 0;
          }
        }
      }

      if (this.placeholder) {
        // $(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately, it unbinds ALL events from the original node!
        if (this.placeholder[0].parentNode) {
          this.placeholder[0].parentNode.removeChild(this.placeholder[0]);
        }
        if (
          this.options.helper !== "original" &&
          this.helper &&
          this.helper[0].parentNode
        ) {
          this.helper.remove();
        }

        $.extend(this, {
          helper: null,
          dragging: false,
          reverting: false,
          _noFinalSort: null,
        });

        if (this.domPosition.prev) {
          $(this.domPosition.prev).after(this.currentItem);
        } else {
          $(this.domPosition.parent).prepend(this.currentItem);
        }
      }

      return this;
    },

    serialize: function (o) {
      var items = this._getItemsAsjQuery(o && o.connected);
      var str = [];
      o = o || {};

      $(items).each(function () {
        var res = ($(o.item || this).attr(o.attribute || "id") || "").match(
          o.expression || /(.+)[\-=_](.+)/
        );
        if (res) {
          str.push(
            (o.key || res[1] + "[]") +
              "=" +
              (o.key && o.expression ? res[1] : res[2])
          );
        }
      });

      if (!str.length && o.key) {
        str.push(o.key + "=");
      }

      return str.join("&");
    },

    toArray: function (o) {
      var items = this._getItemsAsjQuery(o && o.connected);
      var ret = [];

      o = o || {};

      items.each(function () {
        ret.push($(o.item || this).attr(o.attribute || "id") || "");
      });
      return ret;
    },

    /* Be careful with the following core functions */
    _intersectsWith: function (item) {
      var x1 = this.positionAbs.left;
      var x2 = x1 + this.helperProportions.width;
      var y1 = this.positionAbs.top;
      var y2 = y1 + this.helperProportions.height;
      var l = item.left;
      var r = l + item.width;
      var t = item.top;
      var b = t + item.height;
      var dyClick = this.offset.click.top;
      var dxClick = this.offset.click.left;
      var isOverElementHeight =
        this.options.axis === "x" || (y1 + dyClick > t && y1 + dyClick < b);
      var isOverElementWidth =
        this.options.axis === "y" || (x1 + dxClick > l && x1 + dxClick < r);
      var isOverElement = isOverElementHeight && isOverElementWidth;

      if (
        this.options.tolerance === "pointer" ||
        this.options.forcePointerForContainers ||
        (this.options.tolerance !== "pointer" &&
          this.helperProportions[this.floating ? "width" : "height"] >
            item[this.floating ? "width" : "height"])
      ) {
        return isOverElement;
      } else {
        return (
          l < x1 + this.helperProportions.width / 2 && // Right Half
          x2 - this.helperProportions.width / 2 < r && // Left Half
          t < y1 + this.helperProportions.height / 2 && // Bottom Half
          y2 - this.helperProportions.height / 2 < b
        ); // Top Half
      }
    },

    _intersectsWithPointer: function (item) {
      var isOverElementHeight =
        this.options.axis === "x" ||
        isOverAxis(
          this.positionAbs.top + this.offset.click.top,
          item.top,
          item.height
        );
      var isOverElementWidth =
        this.options.axis === "y" ||
        isOverAxis(
          this.positionAbs.left + this.offset.click.left,
          item.left,
          item.width
        );
      var isOverElement = isOverElementHeight && isOverElementWidth;
      var verticalDirection = this._getDragVerticalDirection();
      var horizontalDirection = this._getDragHorizontalDirection();

      if (!isOverElement) {
        return false;
      }

      return this.floating
        ? (horizontalDirection && horizontalDirection === "right") ||
          verticalDirection === "down"
          ? 2
          : 1
        : verticalDirection && (verticalDirection === "down" ? 2 : 1);
    },

    _intersectsWithSides: function (item) {
      var isOverBottomHalf = isOverAxis(
        this.positionAbs.top + this.offset.click.top,
        item.top + item.height / 2,
        item.height
      );
      var isOverRightHalf = isOverAxis(
        this.positionAbs.left + this.offset.click.left,
        item.left + item.width / 2,
        item.width
      );
      var verticalDirection = this._getDragVerticalDirection();
      var horizontalDirection = this._getDragHorizontalDirection();

      if (this.floating && horizontalDirection) {
        return (
          (horizontalDirection === "right" && isOverRightHalf) ||
          (horizontalDirection === "left" && !isOverRightHalf)
        );
      } else {
        return (
          verticalDirection &&
          ((verticalDirection === "down" && isOverBottomHalf) ||
            (verticalDirection === "up" && !isOverBottomHalf))
        );
      }
    },

    _getDragVerticalDirection: function () {
      var delta = this.positionAbs.top - this.lastPositionAbs.top;
      return delta !== 0 && (delta > 0 ? "down" : "up");
    },

    _getDragHorizontalDirection: function () {
      var delta = this.positionAbs.left - this.lastPositionAbs.left;
      return delta !== 0 && (delta > 0 ? "right" : "left");
    },

    refresh: function (event) {
      this._refreshItems(event);
      this.refreshPositions();
      return this;
    },

    _connectWith: function () {
      var options = this.options;
      return options.connectWith.constructor === String
        ? [options.connectWith]
        : options.connectWith;
    },

    _getItemsAsjQuery: function (connected) {
      var i;
      var j;
      var cur;
      var inst;
      var items = [];
      var queries = [];
      var connectWith = this._connectWith();

      if (connectWith && connected) {
        for (i = connectWith.length - 1; i >= 0; i--) {
          cur = $(connectWith[i]);
          for (j = cur.length - 1; j >= 0; j--) {
            inst = $.data(cur[j], this.widgetFullName);
            if (inst && inst !== this && !inst.options.disabled) {
              queries.push([
                $.isFunction(inst.options.items)
                  ? inst.options.items.call(inst.element)
                  : $(inst.options.items, inst.element)
                      .not(".ui-sortable-helper")
                      .not(".ui-sortable-placeholder"),
                inst,
              ]);
            }
          }
        }
      }

      queries.push([
        $.isFunction(this.options.items)
          ? this.options.items.call(this.element, null, {
              options: this.options,
              item: this.currentItem,
            })
          : $(this.options.items, this.element)
              .not(".ui-sortable-helper")
              .not(".ui-sortable-placeholder"),
        this,
      ]);

      for (i = queries.length - 1; i >= 0; i--) {
        queries[i][0].each(function () {
          items.push(this);
        });
      }

      return $(items);
    },

    _removeCurrentsFromItems: function () {
      var list = this.currentItem.find(":data(" + this.widgetName + "-item)");

      this.items = $.grep(this.items, function (item) {
        for (var j = 0; j < list.length; j++) {
          if (list[j] === item.item[0]) {
            return false;
          }
        }
        return true;
      });
    },

    _refreshItems: function (event) {
      this.items = [];
      this.containers = [this];

      var i;
      var j;
      var cur;
      var inst;
      var targetData;
      var _queries;
      var item;
      var queriesLength;
      var items = this.items;
      var queries = [
        [
          $.isFunction(this.options.items)
            ? this.options.items.call(this.element[0], event, {
                item: this.currentItem,
              })
            : $(this.options.items, this.element),
          this,
        ],
      ];
      var connectWith = this._connectWith();

      if (connectWith && this.ready) {
        // Shouldn't be run the first time through due to massive slow-down
        for (i = connectWith.length - 1; i >= 0; i--) {
          cur = $(connectWith[i]);
          for (j = cur.length - 1; j >= 0; j--) {
            inst = $.data(cur[j], this.widgetFullName);
            if (inst && inst !== this && !inst.options.disabled) {
              queries.push([
                $.isFunction(inst.options.items)
                  ? inst.options.items.call(inst.element[0], event, {
                      item: this.currentItem,
                    })
                  : $(inst.options.items, inst.element),
                inst,
              ]);
              this.containers.push(inst);
            }
          }
        }
      }

      for (i = queries.length - 1; i >= 0; i--) {
        targetData = queries[i][1];
        _queries = queries[i][0];

        for (j = 0, queriesLength = _queries.length; j < queriesLength; j++) {
          item = $(_queries[j]);

          item.data(this.widgetName + "-item", targetData); // Data for target checking (mouse manager)

          items.push({
            item: item,
            instance: targetData,
            width: 0,
            height: 0,
            left: 0,
            top: 0,
          });
        }
      }
    },

    refreshPositions: function (fast) {
      // This has to be redone because due to the item being moved out/into the offsetParent, the offsetParent's position will change
      if (this.offsetParent && this.helper) {
        this.offset.parent = this._getParentOffset();
      }

      var i, item, t, p;

      for (i = this.items.length - 1; i >= 0; i--) {
        item = this.items[i];

        // We ignore calculating positions of all connected containers when we're not over them
        if (
          item.instance !== this.currentContainer &&
          this.currentContainer &&
          item.item[0] !== this.currentItem[0]
        ) {
          continue;
        }

        t = this.options.toleranceElement
          ? $(this.options.toleranceElement, item.item)
          : item.item;

        if (!fast) {
          item.width = t.outerWidth();
          item.height = t.outerHeight();
        }

        p = t.offset();
        item.left = p.left;
        item.top = p.top;
      }

      if (this.options.custom && this.options.custom.refreshContainers) {
        this.options.custom.refreshContainers.call(this);
      } else {
        for (i = this.containers.length - 1; i >= 0; i--) {
          p = this.containers[i].element.offset();
          this.containers[i].containerCache.left = p.left;
          this.containers[i].containerCache.top = p.top;
          this.containers[i].containerCache.width = this.containers[
            i
          ].element.outerWidth();
          this.containers[i].containerCache.height = this.containers[
            i
          ].element.outerHeight();
        }
      }

      return this;
    },

    _createPlaceholder: function (that) {
      that = that || this;
      var className;
      var o = that.options;

      if (!o.placeholder || o.placeholder.constructor === String) {
        className = o.placeholder;
        o.placeholder = {
          element: function () {
            var nodeName = that.currentItem[0].nodeName.toLowerCase();
            var element = $("<" + nodeName + ">", that.document[0])
              .addClass(
                className ||
                  that.currentItem[0].className + " ui-sortable-placeholder"
              )
              .removeClass("ui-sortable-helper");

            if (nodeName === "tr") {
              that.currentItem.children().each(function () {
                $("<td>&#160;</td>", that.document[0])
                  .attr("colspan", $(this).attr("colspan") || 1)
                  .appendTo(element);
              });
            } else if (nodeName === "img") {
              element.attr("src", that.currentItem.attr("src"));
            }

            if (!className) {
              element.css("visibility", "hidden");
            }

            return element;
          },
          update: function (container, p) {
            // 1. If a className is set as 'placeholder option, we don't force sizes - the class is responsible for that
            // 2. The option 'forcePlaceholderSize can be enabled to force it even if a class name is specified
            if (className && !o.forcePlaceholderSize) {
              return;
            }

            // If the element doesn't have a actual height by itself (without styles coming from a stylesheet), it receives the inline height from the dragged item
            if (!p.height()) {
              p.height(
                that.currentItem.innerHeight() -
                  parseInt(that.currentItem.css("paddingTop") || 0, 10) -
                  parseInt(that.currentItem.css("paddingBottom") || 0, 10)
              );
            }
            if (!p.width()) {
              p.width(
                that.currentItem.innerWidth() -
                  parseInt(that.currentItem.css("paddingLeft") || 0, 10) -
                  parseInt(that.currentItem.css("paddingRight") || 0, 10)
              );
            }
          },
        };
      }

      // Create the placeholder
      that.placeholder = $(
        o.placeholder.element.call(that.element, that.currentItem)
      );

      // Append it after the actual current item
      that.currentItem.after(that.placeholder);

      // Update the size of the placeholder (TODO: Logic to fuzzy, see line 316/317)
      o.placeholder.update(that, that.placeholder);
    },

    _contactContainers: function (event) {
      var i;
      var j;
      var dist;
      var itemWithLeastDistance;
      var posProperty;
      var sizeProperty;
      var base;
      var cur;
      var nearBottom;
      var floating;
      var innermostContainer = null;
      var innermostIndex = null;

      // get innermost container that intersects with item
      for (i = this.containers.length - 1; i >= 0; i--) {
        // never consider a container that's located within the item itself
        if ($.contains(this.currentItem[0], this.containers[i].element[0])) {
          continue;
        }

        if (this._intersectsWith(this.containers[i].containerCache)) {
          // if we've already found a container and it's more "inner" than this, then continue
          if (
            innermostContainer &&
            $.contains(
              this.containers[i].element[0],
              innermostContainer.element[0]
            )
          ) {
            continue;
          }

          innermostContainer = this.containers[i];
          innermostIndex = i;
        } else {
          // container doesn't intersect. trigger "out" event if necessary
          if (this.containers[i].containerCache.over) {
            this.containers[i]._trigger("out", event, this._uiHash(this));
            this.containers[i].containerCache.over = 0;
          }
        }
      }

      // if no intersecting containers found, return
      if (!innermostContainer) {
        return;
      }

      // move the item into the container if it's not there already
      if (this.containers.length === 1) {
        if (!this.containers[innermostIndex].containerCache.over) {
          this.containers[innermostIndex]._trigger(
            "over",
            event,
            this._uiHash(this)
          );
          this.containers[innermostIndex].containerCache.over = 1;
        }
      } else {
        // When entering a new container, we will find the item with the least distance and append our item near it
        dist = 10000;
        itemWithLeastDistance = null;
        floating = innermostContainer.floating || isFloating(this.currentItem);
        posProperty = floating ? "left" : "top";
        sizeProperty = floating ? "width" : "height";
        base = this.positionAbs[posProperty] + this.offset.click[posProperty];
        for (j = this.items.length - 1; j >= 0; j--) {
          if (
            !$.contains(
              this.containers[innermostIndex].element[0],
              this.items[j].item[0]
            )
          ) {
            continue;
          }
          if (this.items[j].item[0] === this.currentItem[0]) {
            continue;
          }
          if (
            floating &&
            !isOverAxis(
              this.positionAbs.top + this.offset.click.top,
              this.items[j].top,
              this.items[j].height
            )
          ) {
            continue;
          }
          cur = this.items[j].item.offset()[posProperty];
          nearBottom = false;
          if (
            Math.abs(cur - base) >
            Math.abs(cur + this.items[j][sizeProperty] - base)
          ) {
            nearBottom = true;
            cur += this.items[j][sizeProperty];
          }

          if (Math.abs(cur - base) < dist) {
            dist = Math.abs(cur - base);
            itemWithLeastDistance = this.items[j];
            this.direction = nearBottom ? "up" : "down";
          }
        }

        // Check if dropOnEmpty is enabled
        if (!itemWithLeastDistance && !this.options.dropOnEmpty) {
          return;
        }

        if (this.currentContainer === this.containers[innermostIndex]) {
          return;
        }

        itemWithLeastDistance
          ? this._rearrange(event, itemWithLeastDistance, null, true)
          : this._rearrange(
              event,
              null,
              this.containers[innermostIndex].element,
              true
            );
        this._trigger("change", event, this._uiHash());
        this.containers[innermostIndex]._trigger(
          "change",
          event,
          this._uiHash(this)
        );
        this.currentContainer = this.containers[innermostIndex];

        // Update the placeholder
        this.options.placeholder.update(
          this.currentContainer,
          this.placeholder
        );

        this.containers[innermostIndex]._trigger(
          "over",
          event,
          this._uiHash(this)
        );
        this.containers[innermostIndex].containerCache.over = 1;
      }
    },

    _createHelper: function (event) {
      var o = this.options;
      var helper = $.isFunction(o.helper)
        ? $(o.helper.apply(this.element[0], [event, this.currentItem]))
        : o.helper === "clone"
        ? this.currentItem.clone()
        : this.currentItem;

      // Add the helper to the DOM if that didn't happen already
      if (!helper.parents("body").length) {
        $(
          o.appendTo !== "parent" ? o.appendTo : this.currentItem[0].parentNode
        )[0].appendChild(helper[0]);
      }

      if (helper[0] === this.currentItem[0]) {
        this._storedCSS = {
          width: this.currentItem[0].style.width,
          height: this.currentItem[0].style.height,
          position: this.currentItem.css("position"),
          top: this.currentItem.css("top"),
          left: this.currentItem.css("left"),
        };
      }

      if (!helper[0].style.width || o.forceHelperSize) {
        helper.width(this.currentItem.width());
      }
      if (!helper[0].style.height || o.forceHelperSize) {
        helper.height(this.currentItem.height());
      }

      return helper;
    },

    _adjustOffsetFromHelper: function (obj) {
      if (typeof obj === "string") {
        obj = obj.split(" ");
      }
      if ($.isArray(obj)) {
        obj = { left: +obj[0], top: +obj[1] || 0 };
      }
      if ("left" in obj) {
        this.offset.click.left = obj.left + this.margins.left;
      }
      if ("right" in obj) {
        this.offset.click.left =
          this.helperProportions.width - obj.right + this.margins.left;
      }
      if ("top" in obj) {
        this.offset.click.top = obj.top + this.margins.top;
      }
      if ("bottom" in obj) {
        this.offset.click.top =
          this.helperProportions.height - obj.bottom + this.margins.top;
      }
    },

    _getParentOffset: function () {
      // Get the offsetParent and cache its position
      this.offsetParent = this.helper.offsetParent();
      var po = this.offsetParent.offset();

      // This is a special case where we need to modify a offset calculated on start, since the following happened:
      // 1. The position of the helper is absolute, so it's position is calculated based on the next positioned parent
      // 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't the document, which means that
      //    the scroll is included in the initial calculation of the offset of the parent, and never recalculated upon drag
      if (
        this.cssPosition === "absolute" &&
        this.scrollParent[0] !== document &&
        $.contains(this.scrollParent[0], this.offsetParent[0])
      ) {
        po.left += this.scrollParent.scrollLeft();
        po.top += this.scrollParent.scrollTop();
      }

      // This needs to be actually done for all browsers, since pageX/pageY includes this information
      // with an ugly IE fix
      if (
        this.offsetParent[0] === document.body ||
        (this.offsetParent[0].tagName &&
          this.offsetParent[0].tagName.toLowerCase() === "html" &&
          $.ui.ie)
      ) {
        po = { top: 0, left: 0 };
      }

      return {
        top:
          po.top + (parseInt(this.offsetParent.css("borderTopWidth"), 10) || 0),
        left:
          po.left +
          (parseInt(this.offsetParent.css("borderLeftWidth"), 10) || 0),
      };
    },

    _getRelativeOffset: function () {
      if (this.cssPosition === "relative") {
        var p = this.currentItem.position();
        return {
          top:
            p.top -
            (parseInt(this.helper.css("top"), 10) || 0) +
            this.scrollParent.scrollTop(),
          left:
            p.left -
            (parseInt(this.helper.css("left"), 10) || 0) +
            this.scrollParent.scrollLeft(),
        };
      } else {
        return { top: 0, left: 0 };
      }
    },

    _cacheMargins: function () {
      this.margins = {
        left: parseInt(this.currentItem.css("marginLeft"), 10) || 0,
        top: parseInt(this.currentItem.css("marginTop"), 10) || 0,
      };
    },

    _cacheHelperProportions: function () {
      this.helperProportions = {
        width: this.helper.outerWidth(),
        height: this.helper.outerHeight(),
      };
    },

    _setContainment: function () {
      var ce;
      var co;
      var over;
      var o = this.options;
      if (o.containment === "parent") {
        o.containment = this.helper[0].parentNode;
      }
      if (o.containment === "document" || o.containment === "window") {
        this.containment = [
          0 - this.offset.relative.left - this.offset.parent.left,
          0 - this.offset.relative.top - this.offset.parent.top,
          $(o.containment === "document" ? document : window).width() -
            this.helperProportions.width -
            this.margins.left,
          ($(o.containment === "document" ? document : window).height() ||
            document.body.parentNode.scrollHeight) -
            this.helperProportions.height -
            this.margins.top,
        ];
      }

      if (!/^(document|window|parent)$/.test(o.containment)) {
        ce = $(o.containment)[0];
        co = $(o.containment).offset();
        over = $(ce).css("overflow") !== "hidden";

        this.containment = [
          co.left +
            (parseInt($(ce).css("borderLeftWidth"), 10) || 0) +
            (parseInt($(ce).css("paddingLeft"), 10) || 0) -
            this.margins.left,
          co.top +
            (parseInt($(ce).css("borderTopWidth"), 10) || 0) +
            (parseInt($(ce).css("paddingTop"), 10) || 0) -
            this.margins.top,
          co.left +
            (over ? Math.max(ce.scrollWidth, ce.offsetWidth) : ce.offsetWidth) -
            (parseInt($(ce).css("borderLeftWidth"), 10) || 0) -
            (parseInt($(ce).css("paddingRight"), 10) || 0) -
            this.helperProportions.width -
            this.margins.left,
          co.top +
            (over
              ? Math.max(ce.scrollHeight, ce.offsetHeight)
              : ce.offsetHeight) -
            (parseInt($(ce).css("borderTopWidth"), 10) || 0) -
            (parseInt($(ce).css("paddingBottom"), 10) || 0) -
            this.helperProportions.height -
            this.margins.top,
        ];
      }
    },

    _convertPositionTo: function (d, pos) {
      if (!pos) {
        pos = this.position;
      }
      var mod = d === "absolute" ? 1 : -1;
      var scroll =
        this.cssPosition === "absolute" &&
        !(
          this.scrollParent[0] !== document &&
          $.contains(this.scrollParent[0], this.offsetParent[0])
        )
          ? this.offsetParent
          : this.scrollParent;
      var scrollIsRootNode = /(html|body)/i.test(scroll[0].tagName);

      return {
        top:
          pos.top + // The absolute mouse position
          this.offset.relative.top * mod + // Only for relative positioned nodes: Relative offset from element to offset parent
          this.offset.parent.top * mod - // The offsetParent's offset without borders (offset + border)
          (this.cssPosition === "fixed"
            ? -this.scrollParent.scrollTop()
            : scrollIsRootNode
            ? 0
            : scroll.scrollTop()) *
            mod,
        left:
          pos.left + // The absolute mouse position
          this.offset.relative.left * mod + // Only for relative positioned nodes: Relative offset from element to offset parent
          this.offset.parent.left * mod - // The offsetParent's offset without borders (offset + border)
          (this.cssPosition === "fixed"
            ? -this.scrollParent.scrollLeft()
            : scrollIsRootNode
            ? 0
            : scroll.scrollLeft()) *
            mod,
      };
    },

    _generatePosition: function (event) {
      var top;
      var left;
      var o = this.options;
      var pageX = event.pageX;
      var pageY = event.pageY;
      var scroll =
        this.cssPosition === "absolute" &&
        !(
          this.scrollParent[0] !== document &&
          $.contains(this.scrollParent[0], this.offsetParent[0])
        )
          ? this.offsetParent
          : this.scrollParent;
      var scrollIsRootNode = /(html|body)/i.test(scroll[0].tagName);

      // This is another very weird special case that only happens for relative elements:
      // 1. If the css position is relative
      // 2. and the scroll parent is the document or similar to the offset parent
      // we have to refresh the relative offset during the scroll so there are no jumps
      if (
        this.cssPosition === "relative" &&
        !(
          this.scrollParent[0] !== document &&
          this.scrollParent[0] !== this.offsetParent[0]
        )
      ) {
        this.offset.relative = this._getRelativeOffset();
      }

      /*
       * - Position constraining -
       * Constrain the position to a mix of grid, containment.
       */

      if (this.originalPosition) {
        // If we are not dragging yet, we won't check for options
        if (this.containment) {
          if (event.pageX - this.offset.click.left < this.containment[0]) {
            pageX = this.containment[0] + this.offset.click.left;
          }
          if (event.pageY - this.offset.click.top < this.containment[1]) {
            pageY = this.containment[1] + this.offset.click.top;
          }
          if (event.pageX - this.offset.click.left > this.containment[2]) {
            pageX = this.containment[2] + this.offset.click.left;
          }
          if (event.pageY - this.offset.click.top > this.containment[3]) {
            pageY = this.containment[3] + this.offset.click.top;
          }
        }

        if (o.grid) {
          top =
            this.originalPageY +
            Math.round((pageY - this.originalPageY) / o.grid[1]) * o.grid[1];
          pageY = this.containment
            ? top - this.offset.click.top >= this.containment[1] &&
              top - this.offset.click.top <= this.containment[3]
              ? top
              : top - this.offset.click.top >= this.containment[1]
              ? top - o.grid[1]
              : top + o.grid[1]
            : top;

          left =
            this.originalPageX +
            Math.round((pageX - this.originalPageX) / o.grid[0]) * o.grid[0];
          pageX = this.containment
            ? left - this.offset.click.left >= this.containment[0] &&
              left - this.offset.click.left <= this.containment[2]
              ? left
              : left - this.offset.click.left >= this.containment[0]
              ? left - o.grid[0]
              : left + o.grid[0]
            : left;
        }
      }

      return {
        top:
          pageY - // The absolute mouse position
          this.offset.click.top - // Click offset (relative to the element)
          this.offset.relative.top - // Only for relative positioned nodes: Relative offset from element to offset parent
          this.offset.parent.top + // The offsetParent's offset without borders (offset + border)
          (this.cssPosition === "fixed"
            ? -this.scrollParent.scrollTop()
            : scrollIsRootNode
            ? 0
            : scroll.scrollTop()),
        left:
          pageX - // The absolute mouse position
          this.offset.click.left - // Click offset (relative to the element)
          this.offset.relative.left - // Only for relative positioned nodes: Relative offset from element to offset parent
          this.offset.parent.left + // The offsetParent's offset without borders (offset + border)
          (this.cssPosition === "fixed"
            ? -this.scrollParent.scrollLeft()
            : scrollIsRootNode
            ? 0
            : scroll.scrollLeft()),
      };
    },

    _rearrange: function (event, i, a, hardRefresh) {
      a
        ? a[0].appendChild(this.placeholder[0])
        : i.item[0].parentNode.insertBefore(
            this.placeholder[0],
            this.direction === "down" ? i.item[0] : i.item[0].nextSibling
          );

      // Various things done here to improve the performance:
      // 1. we create a setTimeout, that calls refreshPositions
      // 2. on the instance, we have a counter variable, that get's higher after every append
      // 3. on the local scope, we copy the counter variable, and check in the timeout, if it's still the same
      // 4. this lets only the last addition to the timeout stack through
      this.counter = this.counter ? ++this.counter : 1;
      var counter = this.counter;

      this._delay(function () {
        if (counter === this.counter) {
          this.refreshPositions(!hardRefresh); // Precompute after each DOM insertion, NOT on mousemove
        }
      });
    },

    _clear: function (event, noPropagation) {
      this.reverting = false;
      // We delay all events that have to be triggered to after the point where the placeholder has been removed and
      // everything else normalized again
      var i;
      var delayedTriggers = [];

      // We first have to update the dom position of the actual currentItem
      // Note: don't do it if the current item is already removed (by a user), or it gets reappended (see #4088)
      if (!this._noFinalSort && this.currentItem.parent().length) {
        this.placeholder.before(this.currentItem);
      }
      this._noFinalSort = null;

      if (this.helper[0] === this.currentItem[0]) {
        for (i in this._storedCSS) {
          if (
            this._storedCSS[i] === "auto" ||
            this._storedCSS[i] === "static"
          ) {
            this._storedCSS[i] = "";
          }
        }
        this.currentItem.css(this._storedCSS).removeClass("ui-sortable-helper");
      } else {
        this.currentItem.show();
      }

      if (this.fromOutside && !noPropagation) {
        delayedTriggers.push(function (event) {
          this._trigger("receive", event, this._uiHash(this.fromOutside));
        });
      }
      if (
        (this.fromOutside ||
          this.domPosition.prev !==
            this.currentItem.prev().not(".ui-sortable-helper")[0] ||
          this.domPosition.parent !== this.currentItem.parent()[0]) &&
        !noPropagation
      ) {
        delayedTriggers.push(function (event) {
          this._trigger("update", event, this._uiHash());
        }); // Trigger update callback if the DOM position has changed
      }

      // Check if the items Container has Changed and trigger appropriate
      // events.
      if (this !== this.currentContainer) {
        if (!noPropagation) {
          delayedTriggers.push(function (event) {
            this._trigger("remove", event, this._uiHash());
          });
          delayedTriggers.push(
            function (c) {
              return function (event) {
                c._trigger("receive", event, this._uiHash(this));
              };
            }.call(this, this.currentContainer)
          );
          delayedTriggers.push(
            function (c) {
              return function (event) {
                c._trigger("update", event, this._uiHash(this));
              };
            }.call(this, this.currentContainer)
          );
        }
      }

      // Post events to containers
      for (i = this.containers.length - 1; i >= 0; i--) {
        if (!noPropagation) {
          delayedTriggers.push(
            function (c) {
              return function (event) {
                c._trigger("deactivate", event, this._uiHash(this));
              };
            }.call(this, this.containers[i])
          );
        }
        if (this.containers[i].containerCache.over) {
          delayedTriggers.push(
            function (c) {
              return function (event) {
                c._trigger("out", event, this._uiHash(this));
              };
            }.call(this, this.containers[i])
          );
          this.containers[i].containerCache.over = 0;
        }
      }

      // Do what was originally in plugins
      if (this.storedCursor) {
        this.document.find("body").css("cursor", this.storedCursor);
        this.storedStylesheet.remove();
      }
      if (this._storedOpacity) {
        this.helper.css("opacity", this._storedOpacity);
      }
      if (this._storedZIndex) {
        this.helper.css(
          "zIndex",
          this._storedZIndex === "auto" ? "" : this._storedZIndex
        );
      }

      this.dragging = false;
      if (this.cancelHelperRemoval) {
        if (!noPropagation) {
          this._trigger("beforeStop", event, this._uiHash());
          for (i = 0; i < delayedTriggers.length; i++) {
            delayedTriggers[i].call(this, event);
          } // Trigger all delayed events
          this._trigger("stop", event, this._uiHash());
        }

        this.fromOutside = false;
        return false;
      }

      if (!noPropagation) {
        this._trigger("beforeStop", event, this._uiHash());
      }

      // $(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately, it unbinds ALL events from the original node!
      this.placeholder[0].parentNode.removeChild(this.placeholder[0]);

      if (this.helper[0] !== this.currentItem[0]) {
        this.helper.remove();
      }
      this.helper = null;

      if (!noPropagation) {
        for (i = 0; i < delayedTriggers.length; i++) {
          delayedTriggers[i].call(this, event);
        } // Trigger all delayed events
        this._trigger("stop", event, this._uiHash());
      }

      this.fromOutside = false;
      return true;
    },

    _trigger: function () {
      if ($.Widget.prototype._trigger.apply(this, arguments) === false) {
        this.cancel();
      }
    },

    _uiHash: function (_inst) {
      var inst = _inst || this;
      return {
        helper: inst.helper,
        placeholder: inst.placeholder || $([]),
        position: inst.position,
        originalPosition: inst.originalPosition,
        offset: inst.positionAbs,
        item: inst.currentItem,
        sender: _inst ? _inst.element : null,
      };
    },
  });
})(jQuery);
(function ($, undefined) {
  var dataSpace = "ui-effects-";

  $.effects = {
    effect: {},
  };

  /*!
   * jQuery Color Animations v2.1.2
   * https://github.com/jquery/jquery-color
   *
   * Copyright 2013 jQuery Foundation and other contributors
   * Released under the MIT license.
   * http://jquery.org/license
   *
   * Date: Wed Jan 16 08:47:09 2013 -0600
   */
  (function (jQuery, undefined) {
    var stepHooks =
      "backgroundColor borderBottomColor borderLeftColor borderRightColor borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor";

    // plusequals test for += 100 -= 100
    var rplusequals = /^([\-+])=\s*(\d+\.?\d*)/;
    // a set of RE's that can match strings and generate color tuples.
    var stringParsers = [
      {
        re: /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
        parse: function (execResult) {
          return [execResult[1], execResult[2], execResult[3], execResult[4]];
        },
      },
      {
        re: /rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
        parse: function (execResult) {
          return [
            execResult[1] * 2.55,
            execResult[2] * 2.55,
            execResult[3] * 2.55,
            execResult[4],
          ];
        },
      },
      {
        // this regex ignores A-F because it's compared against an already lowercased string
        re: /#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})/,
        parse: function (execResult) {
          return [
            parseInt(execResult[1], 16),
            parseInt(execResult[2], 16),
            parseInt(execResult[3], 16),
          ];
        },
      },
      {
        // this regex ignores A-F because it's compared against an already lowercased string
        re: /#([a-f0-9])([a-f0-9])([a-f0-9])/,
        parse: function (execResult) {
          return [
            parseInt(execResult[1] + execResult[1], 16),
            parseInt(execResult[2] + execResult[2], 16),
            parseInt(execResult[3] + execResult[3], 16),
          ];
        },
      },
      {
        re: /hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
        space: "hsla",
        parse: function (execResult) {
          return [
            execResult[1],
            execResult[2] / 100,
            execResult[3] / 100,
            execResult[4],
          ];
        },
      },
    ];

    // jQuery.Color( )
    var color = (jQuery.Color = function (color, green, blue, alpha) {
      return new jQuery.Color.fn.parse(color, green, blue, alpha);
    });
    var spaces = {
      rgba: {
        props: {
          red: {
            idx: 0,
            type: "byte",
          },
          green: {
            idx: 1,
            type: "byte",
          },
          blue: {
            idx: 2,
            type: "byte",
          },
        },
      },

      hsla: {
        props: {
          hue: {
            idx: 0,
            type: "degrees",
          },
          saturation: {
            idx: 1,
            type: "percent",
          },
          lightness: {
            idx: 2,
            type: "percent",
          },
        },
      },
    };
    var propTypes = {
      byte: {
        floor: true,
        max: 255,
      },
      percent: {
        max: 1,
      },
      degrees: {
        mod: 360,
        floor: true,
      },
    };
    var support = (color.support = {});

    // element for support tests
    var supportElem = jQuery("<p>")[0];

    // colors = jQuery.Color.names
    var colors;

    // local aliases of functions called often
    var each = jQuery.each;

    // determine rgba support immediately
    supportElem.style.cssText = "background-color:rgba(1,1,1,.5)";
    support.rgba = supportElem.style.backgroundColor.indexOf("rgba") > -1;

    // define cache name and alpha properties
    // for rgba and hsla spaces
    each(spaces, function (spaceName, space) {
      space.cache = "_" + spaceName;
      space.props.alpha = {
        idx: 3,
        type: "percent",
        def: 1,
      };
    });

    function clamp(value, prop, allowEmpty) {
      var type = propTypes[prop.type] || {};

      if (value == null) {
        return allowEmpty || !prop.def ? null : prop.def;
      }

      // ~~ is an short way of doing floor for positive numbers
      value = type.floor ? ~~value : parseFloat(value);

      // IE will pass in empty strings as value for alpha,
      // which will hit this case
      if (isNaN(value)) {
        return prop.def;
      }

      if (type.mod) {
        // we add mod before modding to make sure that negatives values
        // get converted properly: -10 -> 350
        return (value + type.mod) % type.mod;
      }

      // for now all property types without mod have min and max
      return value < 0 ? 0 : type.max < value ? type.max : value;
    }

    function stringParse(string) {
      var inst = color();
      var rgba = (inst._rgba = []);

      string = string.toLowerCase();

      each(stringParsers, function (i, parser) {
        var parsed;
        var match = parser.re.exec(string);
        var values = match && parser.parse(match);
        var spaceName = parser.space || "rgba";

        if (values) {
          parsed = inst[spaceName](values);

          // if this was an rgba parse the assignment might happen twice
          // oh well....
          inst[spaces[spaceName].cache] = parsed[spaces[spaceName].cache];
          rgba = inst._rgba = parsed._rgba;

          // exit each( stringParsers ) here because we matched
          return false;
        }
      });

      // Found a stringParser that handled it
      if (rgba.length) {
        // if this came from a parsed string, force "transparent" when alpha is 0
        // chrome, (and maybe others) return "transparent" as rgba(0,0,0,0)
        if (rgba.join() === "0,0,0,0") {
          jQuery.extend(rgba, colors.transparent);
        }
        return inst;
      }

      // named colors
      return colors[string];
    }

    color.fn = jQuery.extend(color.prototype, {
      parse: function (red, green, blue, alpha) {
        if (red === undefined) {
          this._rgba = [null, null, null, null];
          return this;
        }
        if (red.jquery || red.nodeType) {
          red = jQuery(red).css(green);
          green = undefined;
        }

        var inst = this;
        var type = jQuery.type(red);
        var rgba = (this._rgba = []);

        // more than 1 argument specified - assume ( red, green, blue, alpha )
        if (green !== undefined) {
          red = [red, green, blue, alpha];
          type = "array";
        }

        if (type === "string") {
          return this.parse(stringParse(red) || colors._default);
        }

        if (type === "array") {
          each(spaces.rgba.props, function (key, prop) {
            rgba[prop.idx] = clamp(red[prop.idx], prop);
          });
          return this;
        }

        if (type === "object") {
          if (red instanceof color) {
            each(spaces, function (spaceName, space) {
              if (red[space.cache]) {
                inst[space.cache] = red[space.cache].slice();
              }
            });
          } else {
            each(spaces, function (spaceName, space) {
              var cache = space.cache;
              each(space.props, function (key, prop) {
                // if the cache doesn't exist, and we know how to convert
                if (!inst[cache] && space.to) {
                  // if the value was null, we don't need to copy it
                  // if the key was alpha, we don't need to copy it either
                  if (key === "alpha" || red[key] == null) {
                    return;
                  }
                  inst[cache] = space.to(inst._rgba);
                }

                // this is the only case where we allow nulls for ALL properties.
                // call clamp with alwaysAllowEmpty
                inst[cache][prop.idx] = clamp(red[key], prop, true);
              });

              // everything defined but alpha?
              if (
                inst[cache] &&
                jQuery.inArray(null, inst[cache].slice(0, 3)) < 0
              ) {
                // use the default of 1
                inst[cache][3] = 1;
                if (space.from) {
                  inst._rgba = space.from(inst[cache]);
                }
              }
            });
          }
          return this;
        }
      },
      is: function (compare) {
        var is = color(compare);
        var same = true;
        var inst = this;

        each(spaces, function (_, space) {
          var localCache;
          var isCache = is[space.cache];
          if (isCache) {
            localCache =
              inst[space.cache] || (space.to && space.to(inst._rgba)) || [];
            each(space.props, function (_, prop) {
              if (isCache[prop.idx] != null) {
                same = isCache[prop.idx] === localCache[prop.idx];
                return same;
              }
            });
          }
          return same;
        });
        return same;
      },
      _space: function () {
        var used = [];
        var inst = this;
        each(spaces, function (spaceName, space) {
          if (inst[space.cache]) {
            used.push(spaceName);
          }
        });
        return used.pop();
      },
      transition: function (other, distance) {
        var end = color(other);
        var spaceName = end._space();
        var space = spaces[spaceName];
        var startColor = this.alpha() === 0 ? color("transparent") : this;
        var start = startColor[space.cache] || space.to(startColor._rgba);
        var result = start.slice();

        end = end[space.cache];
        each(space.props, function (key, prop) {
          var index = prop.idx;
          var startValue = start[index];
          var endValue = end[index];
          var type = propTypes[prop.type] || {};

          // if null, don't override start value
          if (endValue === null) {
            return;
          }
          // if null - use end
          if (startValue === null) {
            result[index] = endValue;
          } else {
            if (type.mod) {
              if (endValue - startValue > type.mod / 2) {
                startValue += type.mod;
              } else if (startValue - endValue > type.mod / 2) {
                startValue -= type.mod;
              }
            }
            result[index] = clamp(
              (endValue - startValue) * distance + startValue,
              prop
            );
          }
        });
        return this[spaceName](result);
      },
      blend: function (opaque) {
        // if we are already opaque - return ourself
        if (this._rgba[3] === 1) {
          return this;
        }

        var rgb = this._rgba.slice();
        var a = rgb.pop();
        var blend = color(opaque)._rgba;

        return color(
          jQuery.map(rgb, function (v, i) {
            return (1 - a) * blend[i] + a * v;
          })
        );
      },
      toRgbaString: function () {
        var prefix = "rgba(";
        var rgba = jQuery.map(this._rgba, function (v, i) {
          return v == null ? (i > 2 ? 1 : 0) : v;
        });

        if (rgba[3] === 1) {
          rgba.pop();
          prefix = "rgb(";
        }

        return prefix + rgba.join() + ")";
      },
      toHslaString: function () {
        var prefix = "hsla(";
        var hsla = jQuery.map(this.hsla(), function (v, i) {
          if (v == null) {
            v = i > 2 ? 1 : 0;
          }

          // catch 1 and 2
          if (i && i < 3) {
            v = Math.round(v * 100) + "%";
          }
          return v;
        });

        if (hsla[3] === 1) {
          hsla.pop();
          prefix = "hsl(";
        }
        return prefix + hsla.join() + ")";
      },
      toHexString: function (includeAlpha) {
        var rgba = this._rgba.slice();
        var alpha = rgba.pop();

        if (includeAlpha) {
          rgba.push(~~(alpha * 255));
        }

        return (
          "#" +
          jQuery
            .map(rgba, function (v) {
              // default to 0 when nulls exist
              v = (v || 0).toString(16);
              return v.length === 1 ? "0" + v : v;
            })
            .join("")
        );
      },
      toString: function () {
        return this._rgba[3] === 0 ? "transparent" : this.toRgbaString();
      },
    });
    color.fn.parse.prototype = color.fn;

    // hsla conversions adapted from:
    // https://code.google.com/p/maashaack/source/browse/packages/graphics/trunk/src/graphics/colors/HUE2RGB.as?r=5021

    function hue2rgb(p, q, h) {
      h = (h + 1) % 1;
      if (h * 6 < 1) {
        return p + (q - p) * h * 6;
      }
      if (h * 2 < 1) {
        return q;
      }
      if (h * 3 < 2) {
        return p + (q - p) * (2 / 3 - h) * 6;
      }
      return p;
    }

    spaces.hsla.to = function (rgba) {
      if (rgba[0] == null || rgba[1] == null || rgba[2] == null) {
        return [null, null, null, rgba[3]];
      }
      var r = rgba[0] / 255;
      var g = rgba[1] / 255;
      var b = rgba[2] / 255;
      var a = rgba[3];
      var max = Math.max(r, g, b);
      var min = Math.min(r, g, b);
      var diff = max - min;
      var add = max + min;
      var l = add * 0.5;
      var h;
      var s;

      if (min === max) {
        h = 0;
      } else if (r === max) {
        h = (60 * (g - b)) / diff + 360;
      } else if (g === max) {
        h = (60 * (b - r)) / diff + 120;
      } else {
        h = (60 * (r - g)) / diff + 240;
      }

      // chroma (diff) == 0 means greyscale which, by definition, saturation = 0%
      // otherwise, saturation is based on the ratio of chroma (diff) to lightness (add)
      if (diff === 0) {
        s = 0;
      } else if (l <= 0.5) {
        s = diff / add;
      } else {
        s = diff / (2 - add);
      }
      return [Math.round(h) % 360, s, l, a == null ? 1 : a];
    };

    spaces.hsla.from = function (hsla) {
      if (hsla[0] == null || hsla[1] == null || hsla[2] == null) {
        return [null, null, null, hsla[3]];
      }
      var h = hsla[0] / 360;
      var s = hsla[1];
      var l = hsla[2];
      var a = hsla[3];
      var q = l <= 0.5 ? l * (1 + s) : l + s - l * s;
      var p = 2 * l - q;

      return [
        Math.round(hue2rgb(p, q, h + 1 / 3) * 255),
        Math.round(hue2rgb(p, q, h) * 255),
        Math.round(hue2rgb(p, q, h - 1 / 3) * 255),
        a,
      ];
    };

    each(spaces, function (spaceName, space) {
      var props = space.props;
      var cache = space.cache;
      var to = space.to;
      var from = space.from;

      // makes rgba() and hsla()
      color.fn[spaceName] = function (value) {
        // generate a cache for this space if it doesn't exist
        if (to && !this[cache]) {
          this[cache] = to(this._rgba);
        }
        if (value === undefined) {
          return this[cache].slice();
        }

        var ret;
        var type = jQuery.type(value);
        var arr = type === "array" || type === "object" ? value : arguments;
        var local = this[cache].slice();

        each(props, function (key, prop) {
          var val = arr[type === "object" ? key : prop.idx];
          if (val == null) {
            val = local[prop.idx];
          }
          local[prop.idx] = clamp(val, prop);
        });

        if (from) {
          ret = color(from(local));
          ret[cache] = local;
          return ret;
        } else {
          return color(local);
        }
      };

      // makes red() green() blue() alpha() hue() saturation() lightness()
      each(props, function (key, prop) {
        // alpha is included in more than one space
        if (color.fn[key]) {
          return;
        }
        color.fn[key] = function (value) {
          var vtype = jQuery.type(value);
          var fn = key === "alpha" ? (this._hsla ? "hsla" : "rgba") : spaceName;
          var local = this[fn]();
          var cur = local[prop.idx];
          var match;

          if (vtype === "undefined") {
            return cur;
          }

          if (vtype === "function") {
            value = value.call(this, cur);
            vtype = jQuery.type(value);
          }
          if (value == null && prop.empty) {
            return this;
          }
          if (vtype === "string") {
            match = rplusequals.exec(value);
            if (match) {
              value = cur + parseFloat(match[2]) * (match[1] === "+" ? 1 : -1);
            }
          }
          local[prop.idx] = value;
          return this[fn](local);
        };
      });
    });

    // add cssHook and .fx.step function for each named hook.
    // accept a space separated string of properties
    color.hook = function (hook) {
      var hooks = hook.split(" ");
      each(hooks, function (i, hook) {
        jQuery.cssHooks[hook] = {
          set: function (elem, value) {
            var parsed;
            var curElem;
            var backgroundColor = "";

            if (
              value !== "transparent" &&
              (jQuery.type(value) !== "string" || (parsed = stringParse(value)))
            ) {
              value = color(parsed || value);
              if (!support.rgba && value._rgba[3] !== 1) {
                curElem = hook === "backgroundColor" ? elem.parentNode : elem;
                while (
                  (backgroundColor === "" ||
                    backgroundColor === "transparent") &&
                  curElem &&
                  curElem.style
                ) {
                  try {
                    backgroundColor = jQuery.css(curElem, "backgroundColor");
                    curElem = curElem.parentNode;
                  } catch (e) {}
                }

                value = value.blend(
                  backgroundColor && backgroundColor !== "transparent"
                    ? backgroundColor
                    : "_default"
                );
              }

              value = value.toRgbaString();
            }
            try {
              elem.style[hook] = value;
            } catch (e) {
              // wrapped to prevent IE from throwing errors on "invalid" values like 'auto' or 'inherit'
            }
          },
        };
        jQuery.fx.step[hook] = function (fx) {
          if (!fx.colorInit) {
            fx.start = color(fx.elem, hook);
            fx.end = color(fx.end);
            fx.colorInit = true;
          }
          jQuery.cssHooks[hook].set(
            fx.elem,
            fx.start.transition(fx.end, fx.pos)
          );
        };
      });
    };

    color.hook(stepHooks);

    jQuery.cssHooks.borderColor = {
      expand: function (value) {
        var expanded = {};

        each(["Top", "Right", "Bottom", "Left"], function (i, part) {
          expanded["border" + part + "Color"] = value;
        });
        return expanded;
      },
    };

    // Basic color names only.
    // Usage of any of the other color names requires adding yourself or including
    // jquery.color.svg-names.js.
    colors = jQuery.Color.names = {
      // 4.1. Basic color keywords
      aqua: "#00ffff",
      black: "#000000",
      blue: "#0000ff",
      fuchsia: "#ff00ff",
      gray: "#808080",
      green: "#008000",
      lime: "#00ff00",
      maroon: "#800000",
      navy: "#000080",
      olive: "#808000",
      purple: "#800080",
      red: "#ff0000",
      silver: "#c0c0c0",
      teal: "#008080",
      white: "#ffffff",
      yellow: "#ffff00",

      // 4.2.3. "transparent" color keyword
      transparent: [null, null, null, 0],

      _default: "#ffffff",
    };
  })(jQuery);

  /******************************************************************************/
  /** **************************** CLASS ANIMATIONS ******************************/
  /******************************************************************************/
  (function () {
    var classAnimationActions = ["add", "remove", "toggle"];
    var shorthandStyles = {
      border: 1,
      borderBottom: 1,
      borderColor: 1,
      borderLeft: 1,
      borderRight: 1,
      borderTop: 1,
      borderWidth: 1,
      margin: 1,
      padding: 1,
    };

    $.each(
      [
        "borderLeftStyle",
        "borderRightStyle",
        "borderBottomStyle",
        "borderTopStyle",
      ],
      function (_, prop) {
        $.fx.step[prop] = function (fx) {
          if (
            (fx.end !== "none" && !fx.setAttr) ||
            (fx.pos === 1 && !fx.setAttr)
          ) {
            jQuery.style(fx.elem, prop, fx.end);
            fx.setAttr = true;
          }
        };
      }
    );

    function getElementStyles(elem) {
      var key;
      var len;
      var style = elem.ownerDocument.defaultView
        ? elem.ownerDocument.defaultView.getComputedStyle(elem, null)
        : elem.currentStyle;
      var styles = {};

      if (style && style.length && style[0] && style[style[0]]) {
        len = style.length;
        while (len--) {
          key = style[len];
          if (typeof style[key] === "string") {
            styles[$.camelCase(key)] = style[key];
          }
        }
        // support: Opera, IE <9
      } else {
        for (key in style) {
          if (typeof style[key] === "string") {
            styles[key] = style[key];
          }
        }
      }

      return styles;
    }

    function styleDifference(oldStyle, newStyle) {
      var diff = {};
      var name;
      var value;

      for (name in newStyle) {
        value = newStyle[name];
        if (oldStyle[name] !== value) {
          if (!shorthandStyles[name]) {
            if ($.fx.step[name] || !isNaN(parseFloat(value))) {
              diff[name] = value;
            }
          }
        }
      }

      return diff;
    }

    // support: jQuery <1.8
    if (!$.fn.addBack) {
      $.fn.addBack = function (selector) {
        return this.add(
          selector == null ? this.prevObject : this.prevObject.filter(selector)
        );
      };
    }

    $.effects.animateClass = function (value, duration, easing, callback) {
      var o = $.speed(duration, easing, callback);

      return this.queue(function () {
        var animated = $(this);
        var baseClass = animated.attr("class") || "";
        var applyClassChange;
        var allAnimations = o.children
          ? animated.find("*").addBack()
          : animated;

        // map the animated objects to store the original styles.
        allAnimations = allAnimations.map(function () {
          var el = $(this);
          return {
            el: el,
            start: getElementStyles(this),
          };
        });

        // apply class change
        applyClassChange = function () {
          $.each(classAnimationActions, function (i, action) {
            if (value[action]) {
              animated[action + "Class"](value[action]);
            }
          });
        };
        applyClassChange();

        // map all animated objects again - calculate new styles and diff
        allAnimations = allAnimations.map(function () {
          this.end = getElementStyles(this.el[0]);
          this.diff = styleDifference(this.start, this.end);
          return this;
        });

        // apply original class
        animated.attr("class", baseClass);

        // map all animated objects again - this time collecting a promise
        allAnimations = allAnimations.map(function () {
          var styleInfo = this;
          var dfd = $.Deferred();
          var opts = $.extend({}, o, {
            queue: false,
            complete: function () {
              dfd.resolve(styleInfo);
            },
          });

          this.el.animate(this.diff, opts);
          return dfd.promise();
        });

        // once all animations have completed:
        $.when.apply($, allAnimations.get()).done(function () {
          // set the final class
          applyClassChange();

          // for each animated element,
          // clear all css properties that were animated
          $.each(arguments, function () {
            var el = this.el;
            $.each(this.diff, function (key) {
              el.css(key, "");
            });
          });

          // this is guarnteed to be there if you use jQuery.speed()
          // it also handles dequeuing the next anim...
          o.complete.call(animated[0]);
        });
      });
    };

    $.fn.extend({
      addClass: (function (orig) {
        return function (classNames, speed, easing, callback) {
          return speed
            ? $.effects.animateClass.call(
                this,
                { add: classNames },
                speed,
                easing,
                callback
              )
            : orig.apply(this, arguments);
        };
      })($.fn.addClass),

      removeClass: (function (orig) {
        return function (classNames, speed, easing, callback) {
          return arguments.length > 1
            ? $.effects.animateClass.call(
                this,
                { remove: classNames },
                speed,
                easing,
                callback
              )
            : orig.apply(this, arguments);
        };
      })($.fn.removeClass),

      toggleClass: (function (orig) {
        return function (classNames, force, speed, easing, callback) {
          if (typeof force === "boolean" || force === undefined) {
            if (!speed) {
              // without speed parameter
              return orig.apply(this, arguments);
            } else {
              return $.effects.animateClass.call(
                this,
                force ? { add: classNames } : { remove: classNames },
                speed,
                easing,
                callback
              );
            }
          } else {
            // without force parameter
            return $.effects.animateClass.call(
              this,
              { toggle: classNames },
              force,
              speed,
              easing
            );
          }
        };
      })($.fn.toggleClass),

      switchClass: function (remove, add, speed, easing, callback) {
        return $.effects.animateClass.call(
          this,
          {
            add: add,
            remove: remove,
          },
          speed,
          easing,
          callback
        );
      },
    });
  })();

  /******************************************************************************/
  /** ********************************* EFFECTS **********************************/
  /******************************************************************************/

  (function () {
    $.extend($.effects, {
      version: "1.10.3",

      // Saves a set of properties in a data storage
      save: function (element, set) {
        for (var i = 0; i < set.length; i++) {
          if (set[i] !== null) {
            element.data(dataSpace + set[i], element[0].style[set[i]]);
          }
        }
      },

      // Restores a set of previously saved properties from a data storage
      restore: function (element, set) {
        var val, i;
        for (i = 0; i < set.length; i++) {
          if (set[i] !== null) {
            val = element.data(dataSpace + set[i]);
            // support: jQuery 1.6.2
            // http://bugs.jquery.com/ticket/9917
            // jQuery 1.6.2 incorrectly returns undefined for any falsy value.
            // We can't differentiate between "" and 0 here, so we just assume
            // empty string since it's likely to be a more common value...
            if (val === undefined) {
              val = "";
            }
            element.css(set[i], val);
          }
        }
      },

      setMode: function (el, mode) {
        if (mode === "toggle") {
          mode = el.is(":hidden") ? "show" : "hide";
        }
        return mode;
      },

      // Translates a [top,left] array into a baseline value
      // this should be a little more flexible in the future to handle a string & hash
      getBaseline: function (origin, original) {
        var y, x;
        switch (origin[0]) {
          case "top":
            y = 0;
            break;
          case "middle":
            y = 0.5;
            break;
          case "bottom":
            y = 1;
            break;
          default:
            y = origin[0] / original.height;
        }
        switch (origin[1]) {
          case "left":
            x = 0;
            break;
          case "center":
            x = 0.5;
            break;
          case "right":
            x = 1;
            break;
          default:
            x = origin[1] / original.width;
        }
        return {
          x: x,
          y: y,
        };
      },

      // Wraps the element around a wrapper that copies position properties
      createWrapper: function (element) {
        // if the element is already wrapped, return it
        if (element.parent().is(".ui-effects-wrapper")) {
          return element.parent();
        }

        // wrap the element
        var props = {
          width: element.outerWidth(true),
          height: element.outerHeight(true),
          float: element.css("float"),
        };
        var wrapper = $("<div></div>").addClass("ui-effects-wrapper").css({
          fontSize: "100%",
          background: "transparent",
          border: "none",
          margin: 0,
          padding: 0,
        });
        // Store the size in case width/height are defined in % - Fixes #5245
        var size = {
          width: element.width(),
          height: element.height(),
        };
        var active = document.activeElement;

        // support: Firefox
        // Firefox incorrectly exposes anonymous content
        // https://bugzilla.mozilla.org/show_bug.cgi?id=561664
        try {
          active.id;
        } catch (e) {
          active = document.body;
        }

        element.wrap(wrapper);

        // Fixes #7595 - Elements lose focus when wrapped.
        if (element[0] === active || $.contains(element[0], active)) {
          $(active).focus();
        }

        wrapper = element.parent(); // Hotfix for jQuery 1.4 since some change in wrap() seems to actually lose the reference to the wrapped element

        // transfer positioning properties to the wrapper
        if (element.css("position") === "static") {
          wrapper.css({ position: "relative" });
          element.css({ position: "relative" });
        } else {
          $.extend(props, {
            position: element.css("position"),
            zIndex: element.css("z-index"),
          });
          $.each(["top", "left", "bottom", "right"], function (i, pos) {
            props[pos] = element.css(pos);
            if (isNaN(parseInt(props[pos], 10))) {
              props[pos] = "auto";
            }
          });
          element.css({
            position: "relative",
            top: 0,
            left: 0,
            right: "auto",
            bottom: "auto",
          });
        }
        element.css(size);

        return wrapper.css(props).show();
      },

      removeWrapper: function (element) {
        var active = document.activeElement;

        if (element.parent().is(".ui-effects-wrapper")) {
          element.parent().replaceWith(element);

          // Fixes #7595 - Elements lose focus when wrapped.
          if (element[0] === active || $.contains(element[0], active)) {
            $(active).focus();
          }
        }

        return element;
      },

      setTransition: function (element, list, factor, value) {
        value = value || {};
        $.each(list, function (i, x) {
          var unit = element.cssUnit(x);
          if (unit[0] > 0) {
            value[x] = unit[0] * factor + unit[1];
          }
        });
        return value;
      },
    });

    // return an effect options object for the given parameters:
    function _normalizeArguments(effect, options, speed, callback) {
      // allow passing all options as the first parameter
      if ($.isPlainObject(effect)) {
        options = effect;
        effect = effect.effect;
      }

      // convert to an object
      effect = { effect: effect };

      // catch (effect, null, ...)
      if (options == null) {
        options = {};
      }

      // catch (effect, callback)
      if ($.isFunction(options)) {
        callback = options;
        speed = null;
        options = {};
      }

      // catch (effect, speed, ?)
      if (typeof options === "number" || $.fx.speeds[options]) {
        callback = speed;
        speed = options;
        options = {};
      }

      // catch (effect, options, callback)
      if ($.isFunction(speed)) {
        callback = speed;
        speed = null;
      }

      // add options to effect
      if (options) {
        $.extend(effect, options);
      }

      speed = speed || options.duration;
      effect.duration = $.fx.off
        ? 0
        : typeof speed === "number"
        ? speed
        : speed in $.fx.speeds
        ? $.fx.speeds[speed]
        : $.fx.speeds._default;

      effect.complete = callback || options.complete;

      return effect;
    }

    function standardAnimationOption(option) {
      // Valid standard speeds (nothing, number, named speed)
      if (!option || typeof option === "number" || $.fx.speeds[option]) {
        return true;
      }

      // Invalid strings - treat as "normal" speed
      if (typeof option === "string" && !$.effects.effect[option]) {
        return true;
      }

      // Complete callback
      if ($.isFunction(option)) {
        return true;
      }

      // Options hash (but not naming an effect)
      if (typeof option === "object" && !option.effect) {
        return true;
      }

      // Didn't match any standard API
      return false;
    }

    $.fn.extend({
      effect: function (/* effect, options, speed, callback */) {
        var args = _normalizeArguments.apply(this, arguments);
        var mode = args.mode;
        var queue = args.queue;
        var effectMethod = $.effects.effect[args.effect];

        if ($.fx.off || !effectMethod) {
          // delegate to the original method (e.g., .show()) if possible
          if (mode) {
            return this[mode](args.duration, args.complete);
          } else {
            return this.each(function () {
              if (args.complete) {
                args.complete.call(this);
              }
            });
          }
        }

        function run(next) {
          var elem = $(this);
          var complete = args.complete;
          var mode = args.mode;

          function done() {
            if ($.isFunction(complete)) {
              complete.call(elem[0]);
            }
            if ($.isFunction(next)) {
              next();
            }
          }

          // If the element already has the correct final state, delegate to
          // the core methods so the internal tracking of "olddisplay" works.
          if (elem.is(":hidden") ? mode === "hide" : mode === "show") {
            elem[mode]();
            done();
          } else {
            effectMethod.call(elem[0], args, done);
          }
        }

        return queue === false
          ? this.each(run)
          : this.queue(queue || "fx", run);
      },

      show: (function (orig) {
        return function (option) {
          if (standardAnimationOption(option)) {
            return orig.apply(this, arguments);
          } else {
            var args = _normalizeArguments.apply(this, arguments);
            args.mode = "show";
            return this.effect.call(this, args);
          }
        };
      })($.fn.show),

      hide: (function (orig) {
        return function (option) {
          if (standardAnimationOption(option)) {
            return orig.apply(this, arguments);
          } else {
            var args = _normalizeArguments.apply(this, arguments);
            args.mode = "hide";
            return this.effect.call(this, args);
          }
        };
      })($.fn.hide),

      toggle: (function (orig) {
        return function (option) {
          if (standardAnimationOption(option) || typeof option === "boolean") {
            return orig.apply(this, arguments);
          } else {
            var args = _normalizeArguments.apply(this, arguments);
            args.mode = "toggle";
            return this.effect.call(this, args);
          }
        };
      })($.fn.toggle),

      // helper functions
      cssUnit: function (key) {
        var style = this.css(key);
        var val = [];

        $.each(["em", "px", "%", "pt"], function (i, unit) {
          if (style.indexOf(unit) > 0) {
            val = [parseFloat(style), unit];
          }
        });
        return val;
      },
    });
  })();

  /******************************************************************************/
  /** ********************************* EASING ***********************************/
  /******************************************************************************/

  (function () {
    // based on easing equations from Robert Penner (http://www.robertpenner.com/easing)

    var baseEasings = {};

    $.each(["Quad", "Cubic", "Quart", "Quint", "Expo"], function (i, name) {
      baseEasings[name] = function (p) {
        return Math.pow(p, i + 2);
      };
    });

    $.extend(baseEasings, {
      Sine: function (p) {
        return 1 - Math.cos((p * Math.PI) / 2);
      },
      Circ: function (p) {
        return 1 - Math.sqrt(1 - p * p);
      },
      Elastic: function (p) {
        return p === 0 || p === 1
          ? p
          : -Math.pow(2, 8 * (p - 1)) *
              Math.sin((((p - 1) * 80 - 7.5) * Math.PI) / 15);
      },
      Back: function (p) {
        return p * p * (3 * p - 2);
      },
      Bounce: function (p) {
        var pow2;
        var bounce = 4;

        while (p < ((pow2 = Math.pow(2, --bounce)) - 1) / 11) {}
        return (
          1 / Math.pow(4, 3 - bounce) -
          7.5625 * Math.pow((pow2 * 3 - 2) / 22 - p, 2)
        );
      },
    });

    $.each(baseEasings, function (name, easeIn) {
      $.easing["easeIn" + name] = easeIn;
      $.easing["easeOut" + name] = function (p) {
        return 1 - easeIn(1 - p);
      };
      $.easing["easeInOut" + name] = function (p) {
        return p < 0.5 ? easeIn(p * 2) / 2 : 1 - easeIn(p * -2 + 2) / 2;
      };
    });
  })();
})(jQuery);
(function ($, undefined) {
  $.effects.effect.highlight = function (o, done) {
    var elem = $(this);
    var props = ["backgroundImage", "backgroundColor", "opacity"];
    var mode = $.effects.setMode(elem, o.mode || "show");
    var animation = {
      backgroundColor: elem.css("backgroundColor"),
    };

    if (mode === "hide") {
      animation.opacity = 0;
    }

    $.effects.save(elem, props);

    elem
      .show()
      .css({
        backgroundImage: "none",
        backgroundColor: o.color || "#ffff99",
      })
      .animate(animation, {
        queue: false,
        duration: o.duration,
        easing: o.easing,
        complete: function () {
          if (mode === "hide") {
            elem.hide();
          }
          $.effects.restore(elem, props);
          done();
        },
      });
  };
})(jQuery);
